(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49ed"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49ed"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iEDEb", function(module, exports) {

$parcel$export(module.exports, "prepareRegPage", function () { return $d94ab78438d48f81$export$cfa48cda20d0873; });
$parcel$export(module.exports, "isSecondStep", function () { return $d94ab78438d48f81$export$c0206f99f9ed7aa4; });
$parcel$export(module.exports, "goToSecondStep", function () { return $d94ab78438d48f81$export$4ed0938c410fdf5a; });
$parcel$export(module.exports, "isValidToken", function () { return $d94ab78438d48f81$export$9441bd936c2594f9; });
$parcel$export(module.exports, "unlockAccount", function () { return $d94ab78438d48f81$export$5edfb7a6a5229faf; });
$parcel$export(module.exports, "renderAttendeeQR", function () { return $d94ab78438d48f81$export$ee3558d543882588; });
$parcel$export(module.exports, "isNeedToShowPrivacy", function () { return $d94ab78438d48f81$export$af27451b89df1b18; });
$parcel$export(module.exports, "redirectToHome", function () { return $d94ab78438d48f81$export$b380b48c553fe486; });
$parcel$export(module.exports, "generateUrlForEmail", function () { return $d94ab78438d48f81$export$fe14c92a5fee6bfc; });
$parcel$export(module.exports, "initRegForm", function () { return $d94ab78438d48f81$export$cbcf8feac8985513; });
$parcel$export(module.exports, "getErrorRegFallBecauseOfAttendeeNull", function () { return $d94ab78438d48f81$export$fb20e05ada90fbf8; });
$parcel$export(module.exports, "initPrivacyPolicyLink", function () { return $d94ab78438d48f81$export$936be9d1f13b3c83; });

var $ehjkF = parcelRequire("ehjkF");
parcelRequire("cVfVY");

var $iD6my = parcelRequire("iD6my");

var $2oIdW = parcelRequire("2oIdW");

var $b7OGL = parcelRequire("b7OGL");

var $9lxLe = parcelRequire("9lxLe");

var $bIfKR = parcelRequire("bIfKR");

var $2bCNn = parcelRequire("2bCNn");

var $21h3m = parcelRequire("21h3m");
const { eventName: $d94ab78438d48f81$var$eventName, attendeeUid: $d94ab78438d48f81$var$getAttendeeUid } = (0, $b7OGL.pageParams);
function $d94ab78438d48f81$export$cfa48cda20d0873() {
    const eventNameQueryParam = (0, $iD6my.getQueryVariable)("eName");
    if (eventNameQueryParam) (0, $b7OGL.pageParams).saveEventName(eventNameQueryParam);
    if (!(0, $b7OGL.pageParams).homeLink()) {
        const homeLink = window.location.href.replace(/\/[^/]+\.html/, `/${(0, $9lxLe.pageRoutes).index}`);
        if (homeLink) (0, $b7OGL.pageParams).saveHomeLink(homeLink);
    }
}
function $d94ab78438d48f81$export$89e7bec3b8bce705() {
    return localStorage.getItem("step") || "1";
}
function $d94ab78438d48f81$export$c0206f99f9ed7aa4() {
    return $d94ab78438d48f81$export$89e7bec3b8bce705() === "2";
}
function $d94ab78438d48f81$export$4ed0938c410fdf5a() {
    localStorage.setItem("step", "2");
}
function $d94ab78438d48f81$export$9441bd936c2594f9(tokenA, tokenB) {
    if (!tokenA || !tokenB) return false;
    return tokenA === tokenB;
}
async function $d94ab78438d48f81$export$5edfb7a6a5229faf() {
    await (0, $2oIdW.addVisitDateInfo)({
        eventName: (0, $iD6my.getQueryVariable)("eName"),
        uId: $d94ab78438d48f81$var$getAttendeeUid(),
        vDate: new Date(),
        prePaid: true
    });
}
function $d94ab78438d48f81$export$ee3558d543882588(attendeeUid) {
    // NOTE: setTimeout is needed here to fix bug with iPhone because script of qrcode plugin is loaded after this code
    setTimeout(()=>{
        const $qrCodeCont = (0, (/*@__PURE__*/$parcel$interopDefault($ehjkF)))(".qrCode__code");
        const $qrCodeText = (0, (/*@__PURE__*/$parcel$interopDefault($ehjkF)))(".qrCode__text");
        $qrCodeCont.html("");
        const size = parseInt($qrCodeCont.css("width"), 10) - parseInt($qrCodeCont.css("border-width"), 10) * 2;
        $qrCodeCont.qrcode({
            text: attendeeUid,
            label: attendeeUid,
            size: size,
            mode: 0,
            mSize: 0.045,
            mPosX: 0.5,
            mPosY: 0.5,
            fontcolor: "#000",
            fontname: "Arial",
            ecLevel: "H",
            render: "image"
        });
        $qrCodeText.html(attendeeUid);
    }, 0);
}
function $d94ab78438d48f81$export$af27451b89df1b18(opts) {
    return !isEmptyParsedOpts(opts) && Boolean(opts.agreementText);
    function isEmptyParsedOpts(parsedOpts) {
        return Object.keys(parsedOpts || {}).length === 0;
    }
}
function $d94ab78438d48f81$export$b380b48c553fe486() {
    window.location.href = localStorage.getItem("locWA");
}
function $d94ab78438d48f81$export$fe14c92a5fee6bfc() {
    const [currentStringURL] = localStorage.getItem("locWA").split("?");
    const currentURL = new URL(currentStringURL);
    currentURL.searchParams.set("eName", $d94ab78438d48f81$var$eventName());
    return currentURL.href;
}
const $d94ab78438d48f81$var$registerBtn = function initRegisterButton() {
    const $createBtn = (0, (/*@__PURE__*/$parcel$interopDefault($ehjkF)))("#createAtt");
    let currentHandler = null;
    return {
        onClick: (cb)=>{
            // Remove previous listener to prevent duplicate event handlers
            if (currentHandler) $createBtn.off("click", currentHandler);
            currentHandler = cb;
            $createBtn.on("click", currentHandler);
        },
        disable: ()=>{
            $createBtn.prop("disabled", true);
        },
        enable: ()=>{
            $createBtn.prop("disabled", false);
        }
    };
}();
function $d94ab78438d48f81$export$cbcf8feac8985513() {
    let isEnablePhoneNumber = false;
    let isEnableSMSAgreement = false;
    let isEnablePrivacy = false;
    const emailOrPhoneInput = (0, $bIfKR.initEmailOrPhoneInput)();
    return {
        enableAgreePrivacy: enableAgreePrivacy,
        enablePhoneNumber: enablePhoneNumber,
        onSubmit: onSubmit
    };
    function enableAgreePrivacy() {
        isEnablePrivacy = true;
        const $elem = document.querySelector("#agree-privacy");
        $elem.style.display = "inline-flex";
    }
    function enablePhoneNumber(agreementText) {
        emailOrPhoneInput.enablePhoneNumber();
        isEnablePhoneNumber = true;
        if (agreementText) {
            isEnableSMSAgreement = true;
            const $smsAgreement = document.querySelector("#sms-agree .checkbox__text");
            $smsAgreement.textContent = agreementText;
        }
        emailOrPhoneInput.onChangeMode((mode)=>{
            const $smsCheckbox = document.querySelector("#sms-agree");
            if (agreementText) {
                if (mode === "phoneWithCountryCode" || mode === "phoneWithoutCountryCode") $smsCheckbox.style.display = "inline-flex";
                else $smsCheckbox.style.display = "none";
            }
        });
    }
    function extractAttendeeName() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($ehjkF)))("#attendeeName").val().trim();
    }
    function extractAttendeeEmailOrPhoneNumber() {
        return emailOrPhoneInput.get();
    }
    function extractIsCheckedAgreeWithSMSAgreement() {
        const $elem = document.querySelector("#sms-agree");
        if (!$elem) return;
        return $elem.classList.contains("checkbox_checked");
    }
    function extractIsCheckedAgreeWithPrivacy() {
        const $elem = document.querySelector("#agree-privacy");
        if (!$elem) return;
        return $elem.classList.contains("checkbox_checked");
    }
    function onSubmit(cb) {
        $d94ab78438d48f81$var$registerBtn.onClick(async ()=>{
            const $createBtn = (0, (/*@__PURE__*/$parcel$interopDefault($ehjkF)))("#createAtt");
            if ($createBtn.prop("disabled")) return;
            $d94ab78438d48f81$var$registerBtn.disable();
            (0, $2bCNn.validateSync)({
                schema: (0, $21h3m.prepareSchema)({
                    isEnabledSMSAgreement: isEnableSMSAgreement && emailOrPhoneInput.contentType() === "phone",
                    isEnabledPhoneNumber: isEnablePhoneNumber,
                    isEnabledCheckedAgreeWithPrivacy: isEnablePrivacy
                }),
                values: {
                    contact: extractAttendeeEmailOrPhoneNumber(),
                    agreeWithSMSAgreement: extractIsCheckedAgreeWithSMSAgreement(),
                    agreeWithPrivacy: extractIsCheckedAgreeWithPrivacy()
                },
                onError: (error)=>{
                    $d94ab78438d48f81$var$registerBtn.enable();
                    (0, $iD6my.showAlert)(error.errors[0]);
                },
                onSuccess: async ()=>{
                    try {
                        await cb(getData());
                    } catch (e) {
                        console.error("error: ", e);
                        $d94ab78438d48f81$var$registerBtn.enable();
                    }
                }
            });
        });
        $d94ab78438d48f81$var$registerBtn.enable();
    }
    function getData() {
        const result = {
            name: extractAttendeeName()
        };
        const contact = extractAttendeeEmailOrPhoneNumber();
        if ($d94ab78438d48f81$var$isEmail(contact)) result.email = contact;
        else result.phoneNumber = contact;
        return result;
    }
}
function $d94ab78438d48f81$export$fb20e05ada90fbf8({ canBeEmailConfirmationProblem: canBeEmailConfirmationProblem = false } = {}) {
    if (isDev() && canBeEmailConfirmationProblem) return "Failed to create an attendee. Please try again later. Check please your email is confirmed.";
    return "Failed to create an attendee. Please try again later.";
    function isDev() {
        return /dev-|localhost/.test("https://api-new.occo.io/v1");
    }
}
function $d94ab78438d48f81$export$936be9d1f13b3c83() {
    document.querySelector("#privacy-policy").addEventListener("click", ()=>{
        (0, $9lxLe.redirectToPage).privacyPolicy();
    });
}
function $d94ab78438d48f81$var$isEmail(value) {
    return /@/.test(value);
}

});
parcelRegister("cVfVY", function(module, exports) {

/*! jquery-qrcode v0.18.0 - https://larsjung.de/jquery-qrcode/ */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(typeof self !== "undefined" ? self : module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            /******/ Object.defineProperty(exports, "__esModule", {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 0);
    /******/ }([
        /* 0 */ /***/ async function(module1, exports, __webpack_require__) {
            var WIN = window; // eslint-disable-line
            const $ = await Promise.resolve((parcelRequire("ehjkF")));
            var JQ = $;
            var is_img_el = function is_img_el(x) {
                return x && typeof x.tagName === "string" && x.tagName.toUpperCase() === "IMG";
            }; // Wrapper for the original QR code generator.
            var create_qrcode = function create_qrcode(text, level, version, quiet) {
                var qr = {};
                var qr_gen = __webpack_require__(1);
                qr_gen.stringToBytes = qr_gen.stringToBytesFuncs["UTF-8"];
                var vqr = qr_gen(version, level);
                vqr.addData(text);
                vqr.make();
                quiet = quiet || 0;
                var module_count = vqr.getModuleCount();
                var quiet_module_count = module_count + 2 * quiet;
                var is_dark = function is_dark(row, col) {
                    row -= quiet;
                    col -= quiet;
                    return row >= 0 && row < module_count && col >= 0 && col < module_count && vqr.isDark(row, col);
                };
                var add_blank = function add_blank(l, t, r, b) {
                    var prev_is_dark = qr.is_dark;
                    var module_size = 1 / quiet_module_count;
                    qr.is_dark = function(row, col) {
                        var ml = col * module_size;
                        var mt = row * module_size;
                        var mr = ml + module_size;
                        var mb = mt + module_size;
                        return prev_is_dark(row, col) && (l > mr || ml > r || t > mb || mt > b);
                    };
                };
                qr.text = text;
                qr.level = level;
                qr.version = version;
                qr.module_count = quiet_module_count;
                qr.is_dark = is_dark;
                qr.add_blank = add_blank;
                return qr;
            }; // Returns a minimal QR code for the given text starting with version `min_ver`.
            // Returns `undefined` if `text` is too long to be encoded in `max_ver`.
            var create_min_qrcode = function create_min_qrcode(text, level, min_ver, max_ver, quiet) {
                min_ver = Math.max(1, min_ver || 1);
                max_ver = Math.min(40, max_ver || 40);
                for(var ver = min_ver; ver <= max_ver; ver += 1)try {
                    return create_qrcode(text, level, ver, quiet);
                } catch (err) {
                /* empty */ }
                return undefined;
            };
            var draw_background_label = function draw_background_label(qr, ctx, settings) {
                var size = settings.size;
                var font = "bold " + settings.mSize * size + "px " + settings.fontname;
                var tmp_ctx = JQ("<canvas/>")[0].getContext("2d");
                tmp_ctx.font = font;
                var w = tmp_ctx.measureText(settings.label).width;
                var sh = settings.mSize;
                var sw = w / size;
                var sl = (1 - sw) * settings.mPosX;
                var st = (1 - sh) * settings.mPosY;
                var sr = sl + sw;
                var sb = st + sh;
                var pad = 0.01;
                if (settings.mode === 1) // Strip
                qr.add_blank(0, st - pad, size, sb + pad);
                else // Box
                qr.add_blank(sl - pad, st - pad, sr + pad, sb + pad);
                ctx.fillStyle = settings.fontcolor;
                ctx.font = font;
                ctx.fillText(settings.label, sl * size, st * size + 0.75 * settings.mSize * size);
            };
            var draw_background_img = function draw_background_img(qr, ctx, settings) {
                var size = settings.size;
                var w = settings.image.naturalWidth || 1;
                var h = settings.image.naturalHeight || 1;
                var sh = settings.mSize;
                var sw = sh * w / h;
                var sl = (1 - sw) * settings.mPosX;
                var st = (1 - sh) * settings.mPosY;
                var sr = sl + sw;
                var sb = st + sh;
                var pad = 0.01;
                if (settings.mode === 3) // Strip
                qr.add_blank(0, st - pad, size, sb + pad);
                else // Box
                qr.add_blank(sl - pad, st - pad, sr + pad, sb + pad);
                ctx.drawImage(settings.image, sl * size, st * size, sw * size, sh * size);
            };
            var draw_background = function draw_background(qr, ctx, settings) {
                if (is_img_el(settings.background)) ctx.drawImage(settings.background, 0, 0, settings.size, settings.size);
                else if (settings.background) {
                    ctx.fillStyle = settings.background;
                    ctx.fillRect(settings.left, settings.top, settings.size, settings.size);
                }
                var mode = settings.mode;
                if (mode === 1 || mode === 2) draw_background_label(qr, ctx, settings);
                else if (is_img_el(settings.image) && (mode === 3 || mode === 4)) draw_background_img(qr, ctx, settings);
            };
            var draw_modules_default = function draw_modules_default(qr, ctx, settings, left, top, width, row, col) {
                if (qr.is_dark(row, col)) ctx.r(left, top, width, width);
            };
            var draw_modules_rounded_dark = function draw_modules_rounded_dark(ctx, l, t, r, b, rad, nw, ne, se, sw) {
                if (nw) ctx.m(l + rad, t);
                else ctx.m(l, t);
                if (ne) ctx.l(r - rad, t).a(r, t, r, b, rad);
                else ctx.l(r, t);
                if (se) ctx.l(r, b - rad).a(r, b, l, b, rad);
                else ctx.l(r, b);
                if (sw) ctx.l(l + rad, b).a(l, b, l, t, rad);
                else ctx.l(l, b);
                if (nw) ctx.l(l, t + rad).a(l, t, r, t, rad);
                else ctx.l(l, t);
            };
            var draw_modules_rounded_light = function draw_modules_rounded_light(ctx, l, t, r, b, rad, nw, ne, se, sw) {
                if (nw) ctx.m(l + rad, t).l(l, t).l(l, t + rad).a(l, t, l + rad, t, rad);
                if (ne) ctx.m(r - rad, t).l(r, t).l(r, t + rad).a(r, t, r - rad, t, rad);
                if (se) ctx.m(r - rad, b).l(r, b).l(r, b - rad).a(r, b, r - rad, b, rad);
                if (sw) ctx.m(l + rad, b).l(l, b).l(l, b - rad).a(l, b, l + rad, b, rad);
            };
            var draw_modules_rounded = function draw_modules_rounded(qr, ctx, settings, left, top, width, row, col) {
                var right = left + width;
                var bottom = top + width;
                var rad = settings.radius * width;
                var row_n = row - 1;
                var row_s = row + 1;
                var col_w = col - 1;
                var col_e = col + 1;
                var is_dark = qr.is_dark;
                var d_center = is_dark(row, col);
                var d_nw = is_dark(row_n, col_w);
                var d_n = is_dark(row_n, col);
                var d_ne = is_dark(row_n, col_e);
                var d_e = is_dark(row, col_e);
                var d_se = is_dark(row_s, col_e);
                var d_s = is_dark(row_s, col);
                var d_sw = is_dark(row_s, col_w);
                var d_w = is_dark(row, col_w);
                if (d_center) draw_modules_rounded_dark(ctx, left, top, right, bottom, rad, !d_n && !d_w, !d_n && !d_e, !d_s && !d_e, !d_s && !d_w);
                else draw_modules_rounded_light(ctx, left, top, right, bottom, rad, d_n && d_w && d_nw, d_n && d_e && d_ne, d_s && d_e && d_se, d_s && d_w && d_sw);
            };
            var draw_modules = function draw_modules(qr, ctx, settings) {
                var module_count = qr.module_count;
                var module_size = settings.size / module_count;
                var fn = draw_modules_default;
                if (settings.radius > 0 && settings.radius <= 0.5) fn = draw_modules_rounded;
                var draw_ctx = {
                    m: function m(x, y) {
                        ctx.moveTo(x, y);
                        return draw_ctx;
                    },
                    l: function l(x, y) {
                        ctx.lineTo(x, y);
                        return draw_ctx;
                    },
                    a: function a() {
                        ctx.arcTo.apply(ctx, arguments);
                        return draw_ctx;
                    },
                    r: function r() {
                        ctx.rect.apply(ctx, arguments);
                        return draw_ctx;
                    }
                };
                ctx.beginPath();
                for(var row = 0; row < module_count; row += 1)for(var col = 0; col < module_count; col += 1){
                    var l = settings.left + col * module_size;
                    var t = settings.top + row * module_size;
                    var w = module_size;
                    fn(qr, draw_ctx, settings, l, t, w, row, col);
                }
                if (is_img_el(settings.fill)) {
                    ctx.strokeStyle = "rgba(0,0,0,0.5)";
                    ctx.lineWidth = 2;
                    ctx.stroke();
                    var prev = ctx.globalCompositeOperation;
                    ctx.globalCompositeOperation = "destination-out";
                    ctx.fill();
                    ctx.globalCompositeOperation = prev;
                    ctx.clip();
                    ctx.drawImage(settings.fill, 0, 0, settings.size, settings.size);
                    ctx.restore();
                } else {
                    ctx.fillStyle = settings.fill;
                    ctx.fill();
                }
            }; // Draws QR code to the given `canvas` and returns it.
            var draw_on_canvas = function draw_on_canvas(canvas, settings) {
                var qr = create_min_qrcode(settings.text, settings.ecLevel, settings.minVersion, settings.maxVersion, settings.quiet);
                if (!qr) return null;
                var $canvas = JQ(canvas).data("qrcode", qr);
                var ctx = $canvas[0].getContext("2d");
                draw_background(qr, ctx, settings);
                draw_modules(qr, ctx, settings);
                return $canvas;
            }; // Returns a `canvas` element representing the QR code for the given settings.
            var create_canvas = function create_canvas(settings) {
                var $canvas = JQ("<canvas/>").attr("width", settings.size).attr("height", settings.size);
                return draw_on_canvas($canvas, settings);
            }; // Returns an `image` element representing the QR code for the given settings.
            var create_img = function create_img(settings) {
                return JQ("<img/>").attr("src", create_canvas(settings)[0].toDataURL("image/png"));
            }; // Returns a `div` element representing the QR code for the given settings.
            var create_div = function create_div(settings) {
                var qr = create_min_qrcode(settings.text, settings.ecLevel, settings.minVersion, settings.maxVersion, settings.quiet);
                if (!qr) return null;
                 // some shortcuts to improve compression
                var settings_size = settings.size;
                var settings_bgColor = settings.background;
                var math_floor = Math.floor;
                var module_count = qr.module_count;
                var module_size = math_floor(settings_size / module_count);
                var offset = math_floor(0.5 * (settings_size - module_size * module_count));
                var container_css = {
                    position: "relative",
                    left: 0,
                    top: 0,
                    padding: 0,
                    margin: 0,
                    width: settings_size,
                    height: settings_size
                };
                var dark_css = {
                    position: "absolute",
                    padding: 0,
                    margin: 0,
                    width: module_size,
                    height: module_size,
                    "background-color": settings.fill
                };
                var $div = JQ("<div/>").data("qrcode", qr).css(container_css);
                if (settings_bgColor) $div.css("background-color", settings_bgColor);
                for(var row = 0; row < module_count; row += 1){
                    for(var col = 0; col < module_count; col += 1)if (qr.is_dark(row, col)) JQ("<div/>").css(dark_css).css({
                        left: offset + col * module_size,
                        top: offset + row * module_size
                    }).appendTo($div);
                }
                return $div;
            };
            var create_html = function create_html(settings) {
                if (settings.render === "canvas") return create_canvas(settings);
                else if (settings.render === "image") return create_img(settings);
                return create_div(settings);
            };
            var DEFAULTS = {
                // render method: `'canvas'`, `'image'` or `'div'`
                render: "canvas",
                // version range somewhere in 1 .. 40
                minVersion: 1,
                maxVersion: 40,
                // error correction level: `'L'`, `'M'`, `'Q'` or `'H'`
                ecLevel: "L",
                // offset in pixel if drawn onto existing canvas
                left: 0,
                top: 0,
                // size in pixel
                size: 200,
                // code color or image element
                fill: "#000",
                // background color or image element, `null` for transparent background
                background: "#fff",
                // content
                text: "no text",
                // corner radius relative to module width: 0.0 .. 0.5
                radius: 0,
                // quiet zone in modules
                quiet: 0,
                // modes
                // 0: normal
                // 1: label strip
                // 2: label box
                // 3: image strip
                // 4: image box
                mode: 0,
                mSize: 0.1,
                mPosX: 0.5,
                mPosY: 0.5,
                label: "no label",
                fontname: "sans",
                fontcolor: "#000",
                image: null
            };
            JQ.fn.qrcode = module1.exports = function main(options) {
                var settings = JQ.extend({}, DEFAULTS, options);
                return this.each(function(idx, el) {
                    if (el.nodeName.toLowerCase() === "canvas") draw_on_canvas(el, settings);
                    else JQ(el).append(create_html(settings));
                });
            };
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; //---------------------------------------------------------------------
            //
            // QR Code Generator for JavaScript
            //
            // Copyright (c) 2009 Kazuhiko Arase
            //
            // URL: http://www.d-project.com/
            //
            // Licensed under the MIT license:
            //  http://www.opensource.org/licenses/mit-license.php
            //
            // The word 'QR Code' is registered trademark of
            // DENSO WAVE INCORPORATED
            //  http://www.denso-wave.com/qrcode/faqpatent-e.html
            //
            //---------------------------------------------------------------------
            var qrcode = function() {
                //---------------------------------------------------------------------
                // qrcode
                //---------------------------------------------------------------------
                /**
   * qrcode
   * @param typeNumber 1 to 40
   * @param errorCorrectionLevel 'L','M','Q','H'
   */ var qrcode = function(typeNumber, errorCorrectionLevel) {
                    var PAD0 = 0xEC;
                    var PAD1 = 0x11;
                    var _typeNumber = typeNumber;
                    var _errorCorrectionLevel = QRErrorCorrectionLevel[errorCorrectionLevel];
                    var _modules = null;
                    var _moduleCount = 0;
                    var _dataCache = null;
                    var _dataList = [];
                    var _this = {};
                    var makeImpl = function(test, maskPattern) {
                        _moduleCount = _typeNumber * 4 + 17;
                        _modules = function(moduleCount) {
                            var modules = new Array(moduleCount);
                            for(var row = 0; row < moduleCount; row += 1){
                                modules[row] = new Array(moduleCount);
                                for(var col = 0; col < moduleCount; col += 1)modules[row][col] = null;
                            }
                            return modules;
                        }(_moduleCount);
                        setupPositionProbePattern(0, 0);
                        setupPositionProbePattern(_moduleCount - 7, 0);
                        setupPositionProbePattern(0, _moduleCount - 7);
                        setupPositionAdjustPattern();
                        setupTimingPattern();
                        setupTypeInfo(test, maskPattern);
                        if (_typeNumber >= 7) setupTypeNumber(test);
                        if (_dataCache == null) _dataCache = createData(_typeNumber, _errorCorrectionLevel, _dataList);
                        mapData(_dataCache, maskPattern);
                    };
                    var setupPositionProbePattern = function(row, col) {
                        for(var r = -1; r <= 7; r += 1){
                            if (row + r <= -1 || _moduleCount <= row + r) continue;
                            for(var c = -1; c <= 7; c += 1){
                                if (col + c <= -1 || _moduleCount <= col + c) continue;
                                if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) _modules[row + r][col + c] = true;
                                else _modules[row + r][col + c] = false;
                            }
                        }
                    };
                    var getBestMaskPattern = function() {
                        var minLostPoint = 0;
                        var pattern = 0;
                        for(var i = 0; i < 8; i += 1){
                            makeImpl(true, i);
                            var lostPoint = QRUtil.getLostPoint(_this);
                            if (i == 0 || minLostPoint > lostPoint) {
                                minLostPoint = lostPoint;
                                pattern = i;
                            }
                        }
                        return pattern;
                    };
                    var setupTimingPattern = function() {
                        for(var r = 8; r < _moduleCount - 8; r += 1){
                            if (_modules[r][6] != null) continue;
                            _modules[r][6] = r % 2 == 0;
                        }
                        for(var c = 8; c < _moduleCount - 8; c += 1){
                            if (_modules[6][c] != null) continue;
                            _modules[6][c] = c % 2 == 0;
                        }
                    };
                    var setupPositionAdjustPattern = function() {
                        var pos = QRUtil.getPatternPosition(_typeNumber);
                        for(var i = 0; i < pos.length; i += 1)for(var j = 0; j < pos.length; j += 1){
                            var row = pos[i];
                            var col = pos[j];
                            if (_modules[row][col] != null) continue;
                            for(var r = -2; r <= 2; r += 1){
                                for(var c = -2; c <= 2; c += 1)if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) _modules[row + r][col + c] = true;
                                else _modules[row + r][col + c] = false;
                            }
                        }
                    };
                    var setupTypeNumber = function(test) {
                        var bits = QRUtil.getBCHTypeNumber(_typeNumber);
                        for(var i = 0; i < 18; i += 1){
                            var mod = !test && (bits >> i & 1) == 1;
                            _modules[Math.floor(i / 3)][i % 3 + _moduleCount - 8 - 3] = mod;
                        }
                        for(var i = 0; i < 18; i += 1){
                            var mod = !test && (bits >> i & 1) == 1;
                            _modules[i % 3 + _moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
                        }
                    };
                    var setupTypeInfo = function(test, maskPattern) {
                        var data = _errorCorrectionLevel << 3 | maskPattern;
                        var bits = QRUtil.getBCHTypeInfo(data);
                        // vertical
                        for(var i = 0; i < 15; i += 1){
                            var mod = !test && (bits >> i & 1) == 1;
                            if (i < 6) _modules[i][8] = mod;
                            else if (i < 8) _modules[i + 1][8] = mod;
                            else _modules[_moduleCount - 15 + i][8] = mod;
                        }
                        // horizontal
                        for(var i = 0; i < 15; i += 1){
                            var mod = !test && (bits >> i & 1) == 1;
                            if (i < 8) _modules[8][_moduleCount - i - 1] = mod;
                            else if (i < 9) _modules[8][15 - i - 1 + 1] = mod;
                            else _modules[8][15 - i - 1] = mod;
                        }
                        // fixed module
                        _modules[_moduleCount - 8][8] = !test;
                    };
                    var mapData = function(data, maskPattern) {
                        var inc = -1;
                        var row = _moduleCount - 1;
                        var bitIndex = 7;
                        var byteIndex = 0;
                        var maskFunc = QRUtil.getMaskFunction(maskPattern);
                        for(var col = _moduleCount - 1; col > 0; col -= 2){
                            if (col == 6) col -= 1;
                            while(true){
                                for(var c = 0; c < 2; c += 1)if (_modules[row][col - c] == null) {
                                    var dark = false;
                                    if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) == 1;
                                    var mask = maskFunc(row, col - c);
                                    if (mask) dark = !dark;
                                    _modules[row][col - c] = dark;
                                    bitIndex -= 1;
                                    if (bitIndex == -1) {
                                        byteIndex += 1;
                                        bitIndex = 7;
                                    }
                                }
                                row += inc;
                                if (row < 0 || _moduleCount <= row) {
                                    row -= inc;
                                    inc = -inc;
                                    break;
                                }
                            }
                        }
                    };
                    var createBytes = function(buffer, rsBlocks) {
                        var offset = 0;
                        var maxDcCount = 0;
                        var maxEcCount = 0;
                        var dcdata = new Array(rsBlocks.length);
                        var ecdata = new Array(rsBlocks.length);
                        for(var r = 0; r < rsBlocks.length; r += 1){
                            var dcCount = rsBlocks[r].dataCount;
                            var ecCount = rsBlocks[r].totalCount - dcCount;
                            maxDcCount = Math.max(maxDcCount, dcCount);
                            maxEcCount = Math.max(maxEcCount, ecCount);
                            dcdata[r] = new Array(dcCount);
                            for(var i = 0; i < dcdata[r].length; i += 1)dcdata[r][i] = 0xff & buffer.getBuffer()[i + offset];
                            offset += dcCount;
                            var rsPoly = QRUtil.getErrorCorrectPolynomial(ecCount);
                            var rawPoly = qrPolynomial(dcdata[r], rsPoly.getLength() - 1);
                            var modPoly = rawPoly.mod(rsPoly);
                            ecdata[r] = new Array(rsPoly.getLength() - 1);
                            for(var i = 0; i < ecdata[r].length; i += 1){
                                var modIndex = i + modPoly.getLength() - ecdata[r].length;
                                ecdata[r][i] = modIndex >= 0 ? modPoly.getAt(modIndex) : 0;
                            }
                        }
                        var totalCodeCount = 0;
                        for(var i = 0; i < rsBlocks.length; i += 1)totalCodeCount += rsBlocks[i].totalCount;
                        var data = new Array(totalCodeCount);
                        var index = 0;
                        for(var i = 0; i < maxDcCount; i += 1){
                            for(var r = 0; r < rsBlocks.length; r += 1)if (i < dcdata[r].length) {
                                data[index] = dcdata[r][i];
                                index += 1;
                            }
                        }
                        for(var i = 0; i < maxEcCount; i += 1){
                            for(var r = 0; r < rsBlocks.length; r += 1)if (i < ecdata[r].length) {
                                data[index] = ecdata[r][i];
                                index += 1;
                            }
                        }
                        return data;
                    };
                    var createData = function(typeNumber, errorCorrectionLevel, dataList) {
                        var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, errorCorrectionLevel);
                        var buffer = qrBitBuffer();
                        for(var i = 0; i < dataList.length; i += 1){
                            var data = dataList[i];
                            buffer.put(data.getMode(), 4);
                            buffer.put(data.getLength(), QRUtil.getLengthInBits(data.getMode(), typeNumber));
                            data.write(buffer);
                        }
                        // calc num max data.
                        var totalDataCount = 0;
                        for(var i = 0; i < rsBlocks.length; i += 1)totalDataCount += rsBlocks[i].dataCount;
                        if (buffer.getLengthInBits() > totalDataCount * 8) throw "code length overflow. (" + buffer.getLengthInBits() + ">" + totalDataCount * 8 + ")";
                        // end code
                        if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) buffer.put(0, 4);
                        // padding
                        while(buffer.getLengthInBits() % 8 != 0)buffer.putBit(false);
                        // padding
                        while(true){
                            if (buffer.getLengthInBits() >= totalDataCount * 8) break;
                            buffer.put(PAD0, 8);
                            if (buffer.getLengthInBits() >= totalDataCount * 8) break;
                            buffer.put(PAD1, 8);
                        }
                        return createBytes(buffer, rsBlocks);
                    };
                    _this.addData = function(data, mode) {
                        mode = mode || "Byte";
                        var newData = null;
                        switch(mode){
                            case "Numeric":
                                newData = qrNumber(data);
                                break;
                            case "Alphanumeric":
                                newData = qrAlphaNum(data);
                                break;
                            case "Byte":
                                newData = qr8BitByte(data);
                                break;
                            case "Kanji":
                                newData = qrKanji(data);
                                break;
                            default:
                                throw "mode:" + mode;
                        }
                        _dataList.push(newData);
                        _dataCache = null;
                    };
                    _this.isDark = function(row, col) {
                        if (row < 0 || _moduleCount <= row || col < 0 || _moduleCount <= col) throw row + "," + col;
                        return _modules[row][col];
                    };
                    _this.getModuleCount = function() {
                        return _moduleCount;
                    };
                    _this.make = function() {
                        if (_typeNumber < 1) {
                            var typeNumber = 1;
                            for(; typeNumber < 40; typeNumber++){
                                var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, _errorCorrectionLevel);
                                var buffer = qrBitBuffer();
                                for(var i = 0; i < _dataList.length; i++){
                                    var data = _dataList[i];
                                    buffer.put(data.getMode(), 4);
                                    buffer.put(data.getLength(), QRUtil.getLengthInBits(data.getMode(), typeNumber));
                                    data.write(buffer);
                                }
                                var totalDataCount = 0;
                                for(var i = 0; i < rsBlocks.length; i++)totalDataCount += rsBlocks[i].dataCount;
                                if (buffer.getLengthInBits() <= totalDataCount * 8) break;
                            }
                            _typeNumber = typeNumber;
                        }
                        makeImpl(false, getBestMaskPattern());
                    };
                    _this.createTableTag = function(cellSize, margin) {
                        cellSize = cellSize || 2;
                        margin = typeof margin == "undefined" ? cellSize * 4 : margin;
                        var qrHtml = "";
                        qrHtml += '<table style="';
                        qrHtml += " border-width: 0px; border-style: none;";
                        qrHtml += " border-collapse: collapse;";
                        qrHtml += " padding: 0px; margin: " + margin + "px;";
                        qrHtml += '">';
                        qrHtml += "<tbody>";
                        for(var r = 0; r < _this.getModuleCount(); r += 1){
                            qrHtml += "<tr>";
                            for(var c = 0; c < _this.getModuleCount(); c += 1){
                                qrHtml += '<td style="';
                                qrHtml += " border-width: 0px; border-style: none;";
                                qrHtml += " border-collapse: collapse;";
                                qrHtml += " padding: 0px; margin: 0px;";
                                qrHtml += " width: " + cellSize + "px;";
                                qrHtml += " height: " + cellSize + "px;";
                                qrHtml += " background-color: ";
                                qrHtml += _this.isDark(r, c) ? "#000000" : "#ffffff";
                                qrHtml += ";";
                                qrHtml += '"/>';
                            }
                            qrHtml += "</tr>";
                        }
                        qrHtml += "</tbody>";
                        qrHtml += "</table>";
                        return qrHtml;
                    };
                    _this.createSvgTag = function(cellSize, margin, alt, title) {
                        var opts = {};
                        if (typeof arguments[0] == "object") {
                            // Called by options.
                            opts = arguments[0];
                            // overwrite cellSize and margin.
                            cellSize = opts.cellSize;
                            margin = opts.margin;
                            alt = opts.alt;
                            title = opts.title;
                        }
                        cellSize = cellSize || 2;
                        margin = typeof margin == "undefined" ? cellSize * 4 : margin;
                        // Compose alt property surrogate
                        alt = typeof alt === "string" ? {
                            text: alt
                        } : alt || {};
                        alt.text = alt.text || null;
                        alt.id = alt.text ? alt.id || "qrcode-description" : null;
                        // Compose title property surrogate
                        title = typeof title === "string" ? {
                            text: title
                        } : title || {};
                        title.text = title.text || null;
                        title.id = title.text ? title.id || "qrcode-title" : null;
                        var size = _this.getModuleCount() * cellSize + margin * 2;
                        var c, mc, r, mr, qrSvg = "", rect;
                        rect = "l" + cellSize + ",0 0," + cellSize + " -" + cellSize + ",0 0,-" + cellSize + "z ";
                        qrSvg += '<svg version="1.1" xmlns="http://www.w3.org/2000/svg"';
                        qrSvg += !opts.scalable ? ' width="' + size + 'px" height="' + size + 'px"' : "";
                        qrSvg += ' viewBox="0 0 ' + size + " " + size + '" ';
                        qrSvg += ' preserveAspectRatio="xMinYMin meet"';
                        qrSvg += title.text || alt.text ? ' role="img" aria-labelledby="' + escapeXml([
                            title.id,
                            alt.id
                        ].join(" ").trim()) + '"' : "";
                        qrSvg += ">";
                        qrSvg += title.text ? '<title id="' + escapeXml(title.id) + '">' + escapeXml(title.text) + "</title>" : "";
                        qrSvg += alt.text ? '<description id="' + escapeXml(alt.id) + '">' + escapeXml(alt.text) + "</description>" : "";
                        qrSvg += '<rect width="100%" height="100%" fill="white" cx="0" cy="0"/>';
                        qrSvg += '<path d="';
                        for(r = 0; r < _this.getModuleCount(); r += 1){
                            mr = r * cellSize + margin;
                            for(c = 0; c < _this.getModuleCount(); c += 1)if (_this.isDark(r, c)) {
                                mc = c * cellSize + margin;
                                qrSvg += "M" + mc + "," + mr + rect;
                            }
                        }
                        qrSvg += '" stroke="transparent" fill="black"/>';
                        qrSvg += "</svg>";
                        return qrSvg;
                    };
                    _this.createDataURL = function(cellSize, margin) {
                        cellSize = cellSize || 2;
                        margin = typeof margin == "undefined" ? cellSize * 4 : margin;
                        var size = _this.getModuleCount() * cellSize + margin * 2;
                        var min = margin;
                        var max = size - margin;
                        return createDataURL(size, size, function(x, y) {
                            if (min <= x && x < max && min <= y && y < max) {
                                var c = Math.floor((x - min) / cellSize);
                                var r = Math.floor((y - min) / cellSize);
                                return _this.isDark(r, c) ? 0 : 1;
                            } else return 1;
                        });
                    };
                    _this.createImgTag = function(cellSize, margin, alt) {
                        cellSize = cellSize || 2;
                        margin = typeof margin == "undefined" ? cellSize * 4 : margin;
                        var size = _this.getModuleCount() * cellSize + margin * 2;
                        var img = "";
                        img += "<img";
                        img += ' src="';
                        img += _this.createDataURL(cellSize, margin);
                        img += '"';
                        img += ' width="';
                        img += size;
                        img += '"';
                        img += ' height="';
                        img += size;
                        img += '"';
                        if (alt) {
                            img += ' alt="';
                            img += escapeXml(alt);
                            img += '"';
                        }
                        img += "/>";
                        return img;
                    };
                    var escapeXml = function(s) {
                        var escaped = "";
                        for(var i = 0; i < s.length; i += 1){
                            var c = s.charAt(i);
                            switch(c){
                                case "<":
                                    escaped += "&lt;";
                                    break;
                                case ">":
                                    escaped += "&gt;";
                                    break;
                                case "&":
                                    escaped += "&amp;";
                                    break;
                                case '"':
                                    escaped += "&quot;";
                                    break;
                                default:
                                    escaped += c;
                                    break;
                            }
                        }
                        return escaped;
                    };
                    var _createHalfASCII = function(margin) {
                        var cellSize = 1;
                        margin = typeof margin == "undefined" ? cellSize * 2 : margin;
                        var size = _this.getModuleCount() * cellSize + margin * 2;
                        var min = margin;
                        var max = size - margin;
                        var y, x, r1, r2, p;
                        var blocks = {
                            "\u2588\u2588": "\u2588",
                            "\u2588 ": "\u2580",
                            " \u2588": "\u2584",
                            "  ": " "
                        };
                        var blocksLastLineNoMargin = {
                            "\u2588\u2588": "\u2580",
                            "\u2588 ": "\u2580",
                            " \u2588": " ",
                            "  ": " "
                        };
                        var ascii = "";
                        for(y = 0; y < size; y += 2){
                            r1 = Math.floor((y - min) / cellSize);
                            r2 = Math.floor((y + 1 - min) / cellSize);
                            for(x = 0; x < size; x += 1){
                                p = "\u2588";
                                if (min <= x && x < max && min <= y && y < max && _this.isDark(r1, Math.floor((x - min) / cellSize))) p = " ";
                                if (min <= x && x < max && min <= y + 1 && y + 1 < max && _this.isDark(r2, Math.floor((x - min) / cellSize))) p += " ";
                                else p += "\u2588";
                                // Output 2 characters per pixel, to create full square. 1 character per pixels gives only half width of square.
                                ascii += margin < 1 && y + 1 >= max ? blocksLastLineNoMargin[p] : blocks[p];
                            }
                            ascii += "\n";
                        }
                        if (size % 2 && margin > 0) return ascii.substring(0, ascii.length - size - 1) + Array(size + 1).join("\u2580");
                        return ascii.substring(0, ascii.length - 1);
                    };
                    _this.createASCII = function(cellSize, margin) {
                        cellSize = cellSize || 1;
                        if (cellSize < 2) return _createHalfASCII(margin);
                        cellSize -= 1;
                        margin = typeof margin == "undefined" ? cellSize * 2 : margin;
                        var size = _this.getModuleCount() * cellSize + margin * 2;
                        var min = margin;
                        var max = size - margin;
                        var y, x, r, p;
                        var white = Array(cellSize + 1).join("\u2588\u2588");
                        var black = Array(cellSize + 1).join("  ");
                        var ascii = "";
                        var line = "";
                        for(y = 0; y < size; y += 1){
                            r = Math.floor((y - min) / cellSize);
                            line = "";
                            for(x = 0; x < size; x += 1){
                                p = 1;
                                if (min <= x && x < max && min <= y && y < max && _this.isDark(r, Math.floor((x - min) / cellSize))) p = 0;
                                // Output 2 characters per pixel, to create full square. 1 character per pixels gives only half width of square.
                                line += p ? white : black;
                            }
                            for(r = 0; r < cellSize; r += 1)ascii += line + "\n";
                        }
                        return ascii.substring(0, ascii.length - 1);
                    };
                    _this.renderTo2dContext = function(context, cellSize) {
                        cellSize = cellSize || 2;
                        var length = _this.getModuleCount();
                        for(var row = 0; row < length; row++)for(var col = 0; col < length; col++){
                            context.fillStyle = _this.isDark(row, col) ? "black" : "white";
                            context.fillRect(row * cellSize, col * cellSize, cellSize, cellSize);
                        }
                    };
                    return _this;
                };
                //---------------------------------------------------------------------
                // qrcode.stringToBytes
                //---------------------------------------------------------------------
                qrcode.stringToBytesFuncs = {
                    "default": function(s) {
                        var bytes = [];
                        for(var i = 0; i < s.length; i += 1){
                            var c = s.charCodeAt(i);
                            bytes.push(c & 0xff);
                        }
                        return bytes;
                    }
                };
                qrcode.stringToBytes = qrcode.stringToBytesFuncs["default"];
                //---------------------------------------------------------------------
                // qrcode.createStringToBytes
                //---------------------------------------------------------------------
                /**
   * @param unicodeData base64 string of byte array.
   * [16bit Unicode],[16bit Bytes], ...
   * @param numChars
   */ qrcode.createStringToBytes = function(unicodeData, numChars) {
                    // create conversion map.
                    var unicodeMap = function() {
                        var bin = base64DecodeInputStream(unicodeData);
                        var read = function() {
                            var b = bin.read();
                            if (b == -1) throw "eof";
                            return b;
                        };
                        var count = 0;
                        var unicodeMap = {};
                        while(true){
                            var b0 = bin.read();
                            if (b0 == -1) break;
                            var b1 = read();
                            var b2 = read();
                            var b3 = read();
                            var k = String.fromCharCode(b0 << 8 | b1);
                            var v = b2 << 8 | b3;
                            unicodeMap[k] = v;
                            count += 1;
                        }
                        if (count != numChars) throw count + " != " + numChars;
                        return unicodeMap;
                    }();
                    var unknownChar = "?".charCodeAt(0);
                    return function(s) {
                        var bytes = [];
                        for(var i = 0; i < s.length; i += 1){
                            var c = s.charCodeAt(i);
                            if (c < 128) bytes.push(c);
                            else {
                                var b = unicodeMap[s.charAt(i)];
                                if (typeof b == "number") {
                                    if ((b & 0xff) == b) // 1byte
                                    bytes.push(b);
                                    else {
                                        // 2bytes
                                        bytes.push(b >>> 8);
                                        bytes.push(b & 0xff);
                                    }
                                } else bytes.push(unknownChar);
                            }
                        }
                        return bytes;
                    };
                };
                //---------------------------------------------------------------------
                // QRMode
                //---------------------------------------------------------------------
                var QRMode = {
                    MODE_NUMBER: 1,
                    MODE_ALPHA_NUM: 2,
                    MODE_8BIT_BYTE: 4,
                    MODE_KANJI: 8
                };
                //---------------------------------------------------------------------
                // QRErrorCorrectionLevel
                //---------------------------------------------------------------------
                var QRErrorCorrectionLevel = {
                    L: 1,
                    M: 0,
                    Q: 3,
                    H: 2
                };
                //---------------------------------------------------------------------
                // QRMaskPattern
                //---------------------------------------------------------------------
                var QRMaskPattern = {
                    PATTERN000: 0,
                    PATTERN001: 1,
                    PATTERN010: 2,
                    PATTERN011: 3,
                    PATTERN100: 4,
                    PATTERN101: 5,
                    PATTERN110: 6,
                    PATTERN111: 7
                };
                //---------------------------------------------------------------------
                // QRUtil
                //---------------------------------------------------------------------
                var QRUtil = function() {
                    var PATTERN_POSITION_TABLE = [
                        [],
                        [
                            6,
                            18
                        ],
                        [
                            6,
                            22
                        ],
                        [
                            6,
                            26
                        ],
                        [
                            6,
                            30
                        ],
                        [
                            6,
                            34
                        ],
                        [
                            6,
                            22,
                            38
                        ],
                        [
                            6,
                            24,
                            42
                        ],
                        [
                            6,
                            26,
                            46
                        ],
                        [
                            6,
                            28,
                            50
                        ],
                        [
                            6,
                            30,
                            54
                        ],
                        [
                            6,
                            32,
                            58
                        ],
                        [
                            6,
                            34,
                            62
                        ],
                        [
                            6,
                            26,
                            46,
                            66
                        ],
                        [
                            6,
                            26,
                            48,
                            70
                        ],
                        [
                            6,
                            26,
                            50,
                            74
                        ],
                        [
                            6,
                            30,
                            54,
                            78
                        ],
                        [
                            6,
                            30,
                            56,
                            82
                        ],
                        [
                            6,
                            30,
                            58,
                            86
                        ],
                        [
                            6,
                            34,
                            62,
                            90
                        ],
                        [
                            6,
                            28,
                            50,
                            72,
                            94
                        ],
                        [
                            6,
                            26,
                            50,
                            74,
                            98
                        ],
                        [
                            6,
                            30,
                            54,
                            78,
                            102
                        ],
                        [
                            6,
                            28,
                            54,
                            80,
                            106
                        ],
                        [
                            6,
                            32,
                            58,
                            84,
                            110
                        ],
                        [
                            6,
                            30,
                            58,
                            86,
                            114
                        ],
                        [
                            6,
                            34,
                            62,
                            90,
                            118
                        ],
                        [
                            6,
                            26,
                            50,
                            74,
                            98,
                            122
                        ],
                        [
                            6,
                            30,
                            54,
                            78,
                            102,
                            126
                        ],
                        [
                            6,
                            26,
                            52,
                            78,
                            104,
                            130
                        ],
                        [
                            6,
                            30,
                            56,
                            82,
                            108,
                            134
                        ],
                        [
                            6,
                            34,
                            60,
                            86,
                            112,
                            138
                        ],
                        [
                            6,
                            30,
                            58,
                            86,
                            114,
                            142
                        ],
                        [
                            6,
                            34,
                            62,
                            90,
                            118,
                            146
                        ],
                        [
                            6,
                            30,
                            54,
                            78,
                            102,
                            126,
                            150
                        ],
                        [
                            6,
                            24,
                            50,
                            76,
                            102,
                            128,
                            154
                        ],
                        [
                            6,
                            28,
                            54,
                            80,
                            106,
                            132,
                            158
                        ],
                        [
                            6,
                            32,
                            58,
                            84,
                            110,
                            136,
                            162
                        ],
                        [
                            6,
                            26,
                            54,
                            82,
                            110,
                            138,
                            166
                        ],
                        [
                            6,
                            30,
                            58,
                            86,
                            114,
                            142,
                            170
                        ]
                    ];
                    var G15 = 1335;
                    var G18 = 7973;
                    var G15_MASK = 21522;
                    var _this = {};
                    var getBCHDigit = function(data) {
                        var digit = 0;
                        while(data != 0){
                            digit += 1;
                            data >>>= 1;
                        }
                        return digit;
                    };
                    _this.getBCHTypeInfo = function(data) {
                        var d = data << 10;
                        while(getBCHDigit(d) - getBCHDigit(G15) >= 0)d ^= G15 << getBCHDigit(d) - getBCHDigit(G15);
                        return (data << 10 | d) ^ G15_MASK;
                    };
                    _this.getBCHTypeNumber = function(data) {
                        var d = data << 12;
                        while(getBCHDigit(d) - getBCHDigit(G18) >= 0)d ^= G18 << getBCHDigit(d) - getBCHDigit(G18);
                        return data << 12 | d;
                    };
                    _this.getPatternPosition = function(typeNumber) {
                        return PATTERN_POSITION_TABLE[typeNumber - 1];
                    };
                    _this.getMaskFunction = function(maskPattern) {
                        switch(maskPattern){
                            case QRMaskPattern.PATTERN000:
                                return function(i, j) {
                                    return (i + j) % 2 == 0;
                                };
                            case QRMaskPattern.PATTERN001:
                                return function(i, j) {
                                    return i % 2 == 0;
                                };
                            case QRMaskPattern.PATTERN010:
                                return function(i, j) {
                                    return j % 3 == 0;
                                };
                            case QRMaskPattern.PATTERN011:
                                return function(i, j) {
                                    return (i + j) % 3 == 0;
                                };
                            case QRMaskPattern.PATTERN100:
                                return function(i, j) {
                                    return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;
                                };
                            case QRMaskPattern.PATTERN101:
                                return function(i, j) {
                                    return i * j % 2 + i * j % 3 == 0;
                                };
                            case QRMaskPattern.PATTERN110:
                                return function(i, j) {
                                    return (i * j % 2 + i * j % 3) % 2 == 0;
                                };
                            case QRMaskPattern.PATTERN111:
                                return function(i, j) {
                                    return (i * j % 3 + (i + j) % 2) % 2 == 0;
                                };
                            default:
                                throw "bad maskPattern:" + maskPattern;
                        }
                    };
                    _this.getErrorCorrectPolynomial = function(errorCorrectLength) {
                        var a = qrPolynomial([
                            1
                        ], 0);
                        for(var i = 0; i < errorCorrectLength; i += 1)a = a.multiply(qrPolynomial([
                            1,
                            QRMath.gexp(i)
                        ], 0));
                        return a;
                    };
                    _this.getLengthInBits = function(mode, type) {
                        if (1 <= type && type < 10) // 1 - 9
                        switch(mode){
                            case QRMode.MODE_NUMBER:
                                return 10;
                            case QRMode.MODE_ALPHA_NUM:
                                return 9;
                            case QRMode.MODE_8BIT_BYTE:
                                return 8;
                            case QRMode.MODE_KANJI:
                                return 8;
                            default:
                                throw "mode:" + mode;
                        }
                        else if (type < 27) // 10 - 26
                        switch(mode){
                            case QRMode.MODE_NUMBER:
                                return 12;
                            case QRMode.MODE_ALPHA_NUM:
                                return 11;
                            case QRMode.MODE_8BIT_BYTE:
                                return 16;
                            case QRMode.MODE_KANJI:
                                return 10;
                            default:
                                throw "mode:" + mode;
                        }
                        else if (type < 41) // 27 - 40
                        switch(mode){
                            case QRMode.MODE_NUMBER:
                                return 14;
                            case QRMode.MODE_ALPHA_NUM:
                                return 13;
                            case QRMode.MODE_8BIT_BYTE:
                                return 16;
                            case QRMode.MODE_KANJI:
                                return 12;
                            default:
                                throw "mode:" + mode;
                        }
                        else throw "type:" + type;
                    };
                    _this.getLostPoint = function(qrcode) {
                        var moduleCount = qrcode.getModuleCount();
                        var lostPoint = 0;
                        // LEVEL1
                        for(var row = 0; row < moduleCount; row += 1)for(var col = 0; col < moduleCount; col += 1){
                            var sameCount = 0;
                            var dark = qrcode.isDark(row, col);
                            for(var r = -1; r <= 1; r += 1){
                                if (row + r < 0 || moduleCount <= row + r) continue;
                                for(var c = -1; c <= 1; c += 1){
                                    if (col + c < 0 || moduleCount <= col + c) continue;
                                    if (r == 0 && c == 0) continue;
                                    if (dark == qrcode.isDark(row + r, col + c)) sameCount += 1;
                                }
                            }
                            if (sameCount > 5) lostPoint += 3 + sameCount - 5;
                        }
                        // LEVEL2
                        for(var row = 0; row < moduleCount - 1; row += 1)for(var col = 0; col < moduleCount - 1; col += 1){
                            var count = 0;
                            if (qrcode.isDark(row, col)) count += 1;
                            if (qrcode.isDark(row + 1, col)) count += 1;
                            if (qrcode.isDark(row, col + 1)) count += 1;
                            if (qrcode.isDark(row + 1, col + 1)) count += 1;
                            if (count == 0 || count == 4) lostPoint += 3;
                        }
                        // LEVEL3
                        for(var row = 0; row < moduleCount; row += 1){
                            for(var col = 0; col < moduleCount - 6; col += 1)if (qrcode.isDark(row, col) && !qrcode.isDark(row, col + 1) && qrcode.isDark(row, col + 2) && qrcode.isDark(row, col + 3) && qrcode.isDark(row, col + 4) && !qrcode.isDark(row, col + 5) && qrcode.isDark(row, col + 6)) lostPoint += 40;
                        }
                        for(var col = 0; col < moduleCount; col += 1){
                            for(var row = 0; row < moduleCount - 6; row += 1)if (qrcode.isDark(row, col) && !qrcode.isDark(row + 1, col) && qrcode.isDark(row + 2, col) && qrcode.isDark(row + 3, col) && qrcode.isDark(row + 4, col) && !qrcode.isDark(row + 5, col) && qrcode.isDark(row + 6, col)) lostPoint += 40;
                        }
                        // LEVEL4
                        var darkCount = 0;
                        for(var col = 0; col < moduleCount; col += 1){
                            for(var row = 0; row < moduleCount; row += 1)if (qrcode.isDark(row, col)) darkCount += 1;
                        }
                        var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
                        lostPoint += ratio * 10;
                        return lostPoint;
                    };
                    return _this;
                }();
                //---------------------------------------------------------------------
                // QRMath
                //---------------------------------------------------------------------
                var QRMath = function() {
                    var EXP_TABLE = new Array(256);
                    var LOG_TABLE = new Array(256);
                    // initialize tables
                    for(var i = 0; i < 8; i += 1)EXP_TABLE[i] = 1 << i;
                    for(var i = 8; i < 256; i += 1)EXP_TABLE[i] = EXP_TABLE[i - 4] ^ EXP_TABLE[i - 5] ^ EXP_TABLE[i - 6] ^ EXP_TABLE[i - 8];
                    for(var i = 0; i < 255; i += 1)LOG_TABLE[EXP_TABLE[i]] = i;
                    var _this = {};
                    _this.glog = function(n) {
                        if (n < 1) throw "glog(" + n + ")";
                        return LOG_TABLE[n];
                    };
                    _this.gexp = function(n) {
                        while(n < 0)n += 255;
                        while(n >= 256)n -= 255;
                        return EXP_TABLE[n];
                    };
                    return _this;
                }();
                //---------------------------------------------------------------------
                // qrPolynomial
                //---------------------------------------------------------------------
                function qrPolynomial(num, shift) {
                    if (typeof num.length == "undefined") throw num.length + "/" + shift;
                    var _num = function() {
                        var offset = 0;
                        while(offset < num.length && num[offset] == 0)offset += 1;
                        var _num = new Array(num.length - offset + shift);
                        for(var i = 0; i < num.length - offset; i += 1)_num[i] = num[i + offset];
                        return _num;
                    }();
                    var _this = {};
                    _this.getAt = function(index) {
                        return _num[index];
                    };
                    _this.getLength = function() {
                        return _num.length;
                    };
                    _this.multiply = function(e) {
                        var num = new Array(_this.getLength() + e.getLength() - 1);
                        for(var i = 0; i < _this.getLength(); i += 1)for(var j = 0; j < e.getLength(); j += 1)num[i + j] ^= QRMath.gexp(QRMath.glog(_this.getAt(i)) + QRMath.glog(e.getAt(j)));
                        return qrPolynomial(num, 0);
                    };
                    _this.mod = function(e) {
                        if (_this.getLength() - e.getLength() < 0) return _this;
                        var ratio = QRMath.glog(_this.getAt(0)) - QRMath.glog(e.getAt(0));
                        var num = new Array(_this.getLength());
                        for(var i = 0; i < _this.getLength(); i += 1)num[i] = _this.getAt(i);
                        for(var i = 0; i < e.getLength(); i += 1)num[i] ^= QRMath.gexp(QRMath.glog(e.getAt(i)) + ratio);
                        // recursive call
                        return qrPolynomial(num, 0).mod(e);
                    };
                    return _this;
                }
                //---------------------------------------------------------------------
                // QRRSBlock
                //---------------------------------------------------------------------
                var QRRSBlock = function() {
                    var RS_BLOCK_TABLE = [
                        // L
                        // M
                        // Q
                        // H
                        // 1
                        [
                            1,
                            26,
                            19
                        ],
                        [
                            1,
                            26,
                            16
                        ],
                        [
                            1,
                            26,
                            13
                        ],
                        [
                            1,
                            26,
                            9
                        ],
                        // 2
                        [
                            1,
                            44,
                            34
                        ],
                        [
                            1,
                            44,
                            28
                        ],
                        [
                            1,
                            44,
                            22
                        ],
                        [
                            1,
                            44,
                            16
                        ],
                        // 3
                        [
                            1,
                            70,
                            55
                        ],
                        [
                            1,
                            70,
                            44
                        ],
                        [
                            2,
                            35,
                            17
                        ],
                        [
                            2,
                            35,
                            13
                        ],
                        // 4
                        [
                            1,
                            100,
                            80
                        ],
                        [
                            2,
                            50,
                            32
                        ],
                        [
                            2,
                            50,
                            24
                        ],
                        [
                            4,
                            25,
                            9
                        ],
                        // 5
                        [
                            1,
                            134,
                            108
                        ],
                        [
                            2,
                            67,
                            43
                        ],
                        [
                            2,
                            33,
                            15,
                            2,
                            34,
                            16
                        ],
                        [
                            2,
                            33,
                            11,
                            2,
                            34,
                            12
                        ],
                        // 6
                        [
                            2,
                            86,
                            68
                        ],
                        [
                            4,
                            43,
                            27
                        ],
                        [
                            4,
                            43,
                            19
                        ],
                        [
                            4,
                            43,
                            15
                        ],
                        // 7
                        [
                            2,
                            98,
                            78
                        ],
                        [
                            4,
                            49,
                            31
                        ],
                        [
                            2,
                            32,
                            14,
                            4,
                            33,
                            15
                        ],
                        [
                            4,
                            39,
                            13,
                            1,
                            40,
                            14
                        ],
                        // 8
                        [
                            2,
                            121,
                            97
                        ],
                        [
                            2,
                            60,
                            38,
                            2,
                            61,
                            39
                        ],
                        [
                            4,
                            40,
                            18,
                            2,
                            41,
                            19
                        ],
                        [
                            4,
                            40,
                            14,
                            2,
                            41,
                            15
                        ],
                        // 9
                        [
                            2,
                            146,
                            116
                        ],
                        [
                            3,
                            58,
                            36,
                            2,
                            59,
                            37
                        ],
                        [
                            4,
                            36,
                            16,
                            4,
                            37,
                            17
                        ],
                        [
                            4,
                            36,
                            12,
                            4,
                            37,
                            13
                        ],
                        // 10
                        [
                            2,
                            86,
                            68,
                            2,
                            87,
                            69
                        ],
                        [
                            4,
                            69,
                            43,
                            1,
                            70,
                            44
                        ],
                        [
                            6,
                            43,
                            19,
                            2,
                            44,
                            20
                        ],
                        [
                            6,
                            43,
                            15,
                            2,
                            44,
                            16
                        ],
                        // 11
                        [
                            4,
                            101,
                            81
                        ],
                        [
                            1,
                            80,
                            50,
                            4,
                            81,
                            51
                        ],
                        [
                            4,
                            50,
                            22,
                            4,
                            51,
                            23
                        ],
                        [
                            3,
                            36,
                            12,
                            8,
                            37,
                            13
                        ],
                        // 12
                        [
                            2,
                            116,
                            92,
                            2,
                            117,
                            93
                        ],
                        [
                            6,
                            58,
                            36,
                            2,
                            59,
                            37
                        ],
                        [
                            4,
                            46,
                            20,
                            6,
                            47,
                            21
                        ],
                        [
                            7,
                            42,
                            14,
                            4,
                            43,
                            15
                        ],
                        // 13
                        [
                            4,
                            133,
                            107
                        ],
                        [
                            8,
                            59,
                            37,
                            1,
                            60,
                            38
                        ],
                        [
                            8,
                            44,
                            20,
                            4,
                            45,
                            21
                        ],
                        [
                            12,
                            33,
                            11,
                            4,
                            34,
                            12
                        ],
                        // 14
                        [
                            3,
                            145,
                            115,
                            1,
                            146,
                            116
                        ],
                        [
                            4,
                            64,
                            40,
                            5,
                            65,
                            41
                        ],
                        [
                            11,
                            36,
                            16,
                            5,
                            37,
                            17
                        ],
                        [
                            11,
                            36,
                            12,
                            5,
                            37,
                            13
                        ],
                        // 15
                        [
                            5,
                            109,
                            87,
                            1,
                            110,
                            88
                        ],
                        [
                            5,
                            65,
                            41,
                            5,
                            66,
                            42
                        ],
                        [
                            5,
                            54,
                            24,
                            7,
                            55,
                            25
                        ],
                        [
                            11,
                            36,
                            12,
                            7,
                            37,
                            13
                        ],
                        // 16
                        [
                            5,
                            122,
                            98,
                            1,
                            123,
                            99
                        ],
                        [
                            7,
                            73,
                            45,
                            3,
                            74,
                            46
                        ],
                        [
                            15,
                            43,
                            19,
                            2,
                            44,
                            20
                        ],
                        [
                            3,
                            45,
                            15,
                            13,
                            46,
                            16
                        ],
                        // 17
                        [
                            1,
                            135,
                            107,
                            5,
                            136,
                            108
                        ],
                        [
                            10,
                            74,
                            46,
                            1,
                            75,
                            47
                        ],
                        [
                            1,
                            50,
                            22,
                            15,
                            51,
                            23
                        ],
                        [
                            2,
                            42,
                            14,
                            17,
                            43,
                            15
                        ],
                        // 18
                        [
                            5,
                            150,
                            120,
                            1,
                            151,
                            121
                        ],
                        [
                            9,
                            69,
                            43,
                            4,
                            70,
                            44
                        ],
                        [
                            17,
                            50,
                            22,
                            1,
                            51,
                            23
                        ],
                        [
                            2,
                            42,
                            14,
                            19,
                            43,
                            15
                        ],
                        // 19
                        [
                            3,
                            141,
                            113,
                            4,
                            142,
                            114
                        ],
                        [
                            3,
                            70,
                            44,
                            11,
                            71,
                            45
                        ],
                        [
                            17,
                            47,
                            21,
                            4,
                            48,
                            22
                        ],
                        [
                            9,
                            39,
                            13,
                            16,
                            40,
                            14
                        ],
                        // 20
                        [
                            3,
                            135,
                            107,
                            5,
                            136,
                            108
                        ],
                        [
                            3,
                            67,
                            41,
                            13,
                            68,
                            42
                        ],
                        [
                            15,
                            54,
                            24,
                            5,
                            55,
                            25
                        ],
                        [
                            15,
                            43,
                            15,
                            10,
                            44,
                            16
                        ],
                        // 21
                        [
                            4,
                            144,
                            116,
                            4,
                            145,
                            117
                        ],
                        [
                            17,
                            68,
                            42
                        ],
                        [
                            17,
                            50,
                            22,
                            6,
                            51,
                            23
                        ],
                        [
                            19,
                            46,
                            16,
                            6,
                            47,
                            17
                        ],
                        // 22
                        [
                            2,
                            139,
                            111,
                            7,
                            140,
                            112
                        ],
                        [
                            17,
                            74,
                            46
                        ],
                        [
                            7,
                            54,
                            24,
                            16,
                            55,
                            25
                        ],
                        [
                            34,
                            37,
                            13
                        ],
                        // 23
                        [
                            4,
                            151,
                            121,
                            5,
                            152,
                            122
                        ],
                        [
                            4,
                            75,
                            47,
                            14,
                            76,
                            48
                        ],
                        [
                            11,
                            54,
                            24,
                            14,
                            55,
                            25
                        ],
                        [
                            16,
                            45,
                            15,
                            14,
                            46,
                            16
                        ],
                        // 24
                        [
                            6,
                            147,
                            117,
                            4,
                            148,
                            118
                        ],
                        [
                            6,
                            73,
                            45,
                            14,
                            74,
                            46
                        ],
                        [
                            11,
                            54,
                            24,
                            16,
                            55,
                            25
                        ],
                        [
                            30,
                            46,
                            16,
                            2,
                            47,
                            17
                        ],
                        // 25
                        [
                            8,
                            132,
                            106,
                            4,
                            133,
                            107
                        ],
                        [
                            8,
                            75,
                            47,
                            13,
                            76,
                            48
                        ],
                        [
                            7,
                            54,
                            24,
                            22,
                            55,
                            25
                        ],
                        [
                            22,
                            45,
                            15,
                            13,
                            46,
                            16
                        ],
                        // 26
                        [
                            10,
                            142,
                            114,
                            2,
                            143,
                            115
                        ],
                        [
                            19,
                            74,
                            46,
                            4,
                            75,
                            47
                        ],
                        [
                            28,
                            50,
                            22,
                            6,
                            51,
                            23
                        ],
                        [
                            33,
                            46,
                            16,
                            4,
                            47,
                            17
                        ],
                        // 27
                        [
                            8,
                            152,
                            122,
                            4,
                            153,
                            123
                        ],
                        [
                            22,
                            73,
                            45,
                            3,
                            74,
                            46
                        ],
                        [
                            8,
                            53,
                            23,
                            26,
                            54,
                            24
                        ],
                        [
                            12,
                            45,
                            15,
                            28,
                            46,
                            16
                        ],
                        // 28
                        [
                            3,
                            147,
                            117,
                            10,
                            148,
                            118
                        ],
                        [
                            3,
                            73,
                            45,
                            23,
                            74,
                            46
                        ],
                        [
                            4,
                            54,
                            24,
                            31,
                            55,
                            25
                        ],
                        [
                            11,
                            45,
                            15,
                            31,
                            46,
                            16
                        ],
                        // 29
                        [
                            7,
                            146,
                            116,
                            7,
                            147,
                            117
                        ],
                        [
                            21,
                            73,
                            45,
                            7,
                            74,
                            46
                        ],
                        [
                            1,
                            53,
                            23,
                            37,
                            54,
                            24
                        ],
                        [
                            19,
                            45,
                            15,
                            26,
                            46,
                            16
                        ],
                        // 30
                        [
                            5,
                            145,
                            115,
                            10,
                            146,
                            116
                        ],
                        [
                            19,
                            75,
                            47,
                            10,
                            76,
                            48
                        ],
                        [
                            15,
                            54,
                            24,
                            25,
                            55,
                            25
                        ],
                        [
                            23,
                            45,
                            15,
                            25,
                            46,
                            16
                        ],
                        // 31
                        [
                            13,
                            145,
                            115,
                            3,
                            146,
                            116
                        ],
                        [
                            2,
                            74,
                            46,
                            29,
                            75,
                            47
                        ],
                        [
                            42,
                            54,
                            24,
                            1,
                            55,
                            25
                        ],
                        [
                            23,
                            45,
                            15,
                            28,
                            46,
                            16
                        ],
                        // 32
                        [
                            17,
                            145,
                            115
                        ],
                        [
                            10,
                            74,
                            46,
                            23,
                            75,
                            47
                        ],
                        [
                            10,
                            54,
                            24,
                            35,
                            55,
                            25
                        ],
                        [
                            19,
                            45,
                            15,
                            35,
                            46,
                            16
                        ],
                        // 33
                        [
                            17,
                            145,
                            115,
                            1,
                            146,
                            116
                        ],
                        [
                            14,
                            74,
                            46,
                            21,
                            75,
                            47
                        ],
                        [
                            29,
                            54,
                            24,
                            19,
                            55,
                            25
                        ],
                        [
                            11,
                            45,
                            15,
                            46,
                            46,
                            16
                        ],
                        // 34
                        [
                            13,
                            145,
                            115,
                            6,
                            146,
                            116
                        ],
                        [
                            14,
                            74,
                            46,
                            23,
                            75,
                            47
                        ],
                        [
                            44,
                            54,
                            24,
                            7,
                            55,
                            25
                        ],
                        [
                            59,
                            46,
                            16,
                            1,
                            47,
                            17
                        ],
                        // 35
                        [
                            12,
                            151,
                            121,
                            7,
                            152,
                            122
                        ],
                        [
                            12,
                            75,
                            47,
                            26,
                            76,
                            48
                        ],
                        [
                            39,
                            54,
                            24,
                            14,
                            55,
                            25
                        ],
                        [
                            22,
                            45,
                            15,
                            41,
                            46,
                            16
                        ],
                        // 36
                        [
                            6,
                            151,
                            121,
                            14,
                            152,
                            122
                        ],
                        [
                            6,
                            75,
                            47,
                            34,
                            76,
                            48
                        ],
                        [
                            46,
                            54,
                            24,
                            10,
                            55,
                            25
                        ],
                        [
                            2,
                            45,
                            15,
                            64,
                            46,
                            16
                        ],
                        // 37
                        [
                            17,
                            152,
                            122,
                            4,
                            153,
                            123
                        ],
                        [
                            29,
                            74,
                            46,
                            14,
                            75,
                            47
                        ],
                        [
                            49,
                            54,
                            24,
                            10,
                            55,
                            25
                        ],
                        [
                            24,
                            45,
                            15,
                            46,
                            46,
                            16
                        ],
                        // 38
                        [
                            4,
                            152,
                            122,
                            18,
                            153,
                            123
                        ],
                        [
                            13,
                            74,
                            46,
                            32,
                            75,
                            47
                        ],
                        [
                            48,
                            54,
                            24,
                            14,
                            55,
                            25
                        ],
                        [
                            42,
                            45,
                            15,
                            32,
                            46,
                            16
                        ],
                        // 39
                        [
                            20,
                            147,
                            117,
                            4,
                            148,
                            118
                        ],
                        [
                            40,
                            75,
                            47,
                            7,
                            76,
                            48
                        ],
                        [
                            43,
                            54,
                            24,
                            22,
                            55,
                            25
                        ],
                        [
                            10,
                            45,
                            15,
                            67,
                            46,
                            16
                        ],
                        // 40
                        [
                            19,
                            148,
                            118,
                            6,
                            149,
                            119
                        ],
                        [
                            18,
                            75,
                            47,
                            31,
                            76,
                            48
                        ],
                        [
                            34,
                            54,
                            24,
                            34,
                            55,
                            25
                        ],
                        [
                            20,
                            45,
                            15,
                            61,
                            46,
                            16
                        ]
                    ];
                    var qrRSBlock = function(totalCount, dataCount) {
                        var _this = {};
                        _this.totalCount = totalCount;
                        _this.dataCount = dataCount;
                        return _this;
                    };
                    var _this = {};
                    var getRsBlockTable = function(typeNumber, errorCorrectionLevel) {
                        switch(errorCorrectionLevel){
                            case QRErrorCorrectionLevel.L:
                                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
                            case QRErrorCorrectionLevel.M:
                                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
                            case QRErrorCorrectionLevel.Q:
                                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
                            case QRErrorCorrectionLevel.H:
                                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
                            default:
                                return undefined;
                        }
                    };
                    _this.getRSBlocks = function(typeNumber, errorCorrectionLevel) {
                        var rsBlock = getRsBlockTable(typeNumber, errorCorrectionLevel);
                        if (typeof rsBlock == "undefined") throw "bad rs block @ typeNumber:" + typeNumber + "/errorCorrectionLevel:" + errorCorrectionLevel;
                        var length = rsBlock.length / 3;
                        var list = [];
                        for(var i = 0; i < length; i += 1){
                            var count = rsBlock[i * 3 + 0];
                            var totalCount = rsBlock[i * 3 + 1];
                            var dataCount = rsBlock[i * 3 + 2];
                            for(var j = 0; j < count; j += 1)list.push(qrRSBlock(totalCount, dataCount));
                        }
                        return list;
                    };
                    return _this;
                }();
                //---------------------------------------------------------------------
                // qrBitBuffer
                //---------------------------------------------------------------------
                var qrBitBuffer = function() {
                    var _buffer = [];
                    var _length = 0;
                    var _this = {};
                    _this.getBuffer = function() {
                        return _buffer;
                    };
                    _this.getAt = function(index) {
                        var bufIndex = Math.floor(index / 8);
                        return (_buffer[bufIndex] >>> 7 - index % 8 & 1) == 1;
                    };
                    _this.put = function(num, length) {
                        for(var i = 0; i < length; i += 1)_this.putBit((num >>> length - i - 1 & 1) == 1);
                    };
                    _this.getLengthInBits = function() {
                        return _length;
                    };
                    _this.putBit = function(bit) {
                        var bufIndex = Math.floor(_length / 8);
                        if (_buffer.length <= bufIndex) _buffer.push(0);
                        if (bit) _buffer[bufIndex] |= 0x80 >>> _length % 8;
                        _length += 1;
                    };
                    return _this;
                };
                //---------------------------------------------------------------------
                // qrNumber
                //---------------------------------------------------------------------
                var qrNumber = function(data) {
                    var _mode = QRMode.MODE_NUMBER;
                    var _data = data;
                    var _this = {};
                    _this.getMode = function() {
                        return _mode;
                    };
                    _this.getLength = function(buffer) {
                        return _data.length;
                    };
                    _this.write = function(buffer) {
                        var data = _data;
                        var i = 0;
                        while(i + 2 < data.length){
                            buffer.put(strToNum(data.substring(i, i + 3)), 10);
                            i += 3;
                        }
                        if (i < data.length) {
                            if (data.length - i == 1) buffer.put(strToNum(data.substring(i, i + 1)), 4);
                            else if (data.length - i == 2) buffer.put(strToNum(data.substring(i, i + 2)), 7);
                        }
                    };
                    var strToNum = function(s) {
                        var num = 0;
                        for(var i = 0; i < s.length; i += 1)num = num * 10 + chatToNum(s.charAt(i));
                        return num;
                    };
                    var chatToNum = function(c) {
                        if ("0" <= c && c <= "9") return c.charCodeAt(0) - "0".charCodeAt(0);
                        throw "illegal char :" + c;
                    };
                    return _this;
                };
                //---------------------------------------------------------------------
                // qrAlphaNum
                //---------------------------------------------------------------------
                var qrAlphaNum = function(data) {
                    var _mode = QRMode.MODE_ALPHA_NUM;
                    var _data = data;
                    var _this = {};
                    _this.getMode = function() {
                        return _mode;
                    };
                    _this.getLength = function(buffer) {
                        return _data.length;
                    };
                    _this.write = function(buffer) {
                        var s = _data;
                        var i = 0;
                        while(i + 1 < s.length){
                            buffer.put(getCode(s.charAt(i)) * 45 + getCode(s.charAt(i + 1)), 11);
                            i += 2;
                        }
                        if (i < s.length) buffer.put(getCode(s.charAt(i)), 6);
                    };
                    var getCode = function(c) {
                        if ("0" <= c && c <= "9") return c.charCodeAt(0) - "0".charCodeAt(0);
                        else if ("A" <= c && c <= "Z") return c.charCodeAt(0) - "A".charCodeAt(0) + 10;
                        else switch(c){
                            case " ":
                                return 36;
                            case "$":
                                return 37;
                            case "%":
                                return 38;
                            case "*":
                                return 39;
                            case "+":
                                return 40;
                            case "-":
                                return 41;
                            case ".":
                                return 42;
                            case "/":
                                return 43;
                            case ":":
                                return 44;
                            default:
                                throw "illegal char :" + c;
                        }
                    };
                    return _this;
                };
                //---------------------------------------------------------------------
                // qr8BitByte
                //---------------------------------------------------------------------
                var qr8BitByte = function(data) {
                    var _mode = QRMode.MODE_8BIT_BYTE;
                    var _data = data;
                    var _bytes = qrcode.stringToBytes(data);
                    var _this = {};
                    _this.getMode = function() {
                        return _mode;
                    };
                    _this.getLength = function(buffer) {
                        return _bytes.length;
                    };
                    _this.write = function(buffer) {
                        for(var i = 0; i < _bytes.length; i += 1)buffer.put(_bytes[i], 8);
                    };
                    return _this;
                };
                //---------------------------------------------------------------------
                // qrKanji
                //---------------------------------------------------------------------
                var qrKanji = function(data) {
                    var _mode = QRMode.MODE_KANJI;
                    var _data = data;
                    var stringToBytes = qrcode.stringToBytesFuncs["SJIS"];
                    if (!stringToBytes) throw "sjis not supported.";
                    !function(c, code) {
                        // self test for sjis support.
                        var test = stringToBytes(c);
                        if (test.length != 2 || (test[0] << 8 | test[1]) != code) throw "sjis not supported.";
                    }("\u53CB", 0x9746);
                    var _bytes = stringToBytes(data);
                    var _this = {};
                    _this.getMode = function() {
                        return _mode;
                    };
                    _this.getLength = function(buffer) {
                        return ~~(_bytes.length / 2);
                    };
                    _this.write = function(buffer) {
                        var data = _bytes;
                        var i = 0;
                        while(i + 1 < data.length){
                            var c = (0xff & data[i]) << 8 | 0xff & data[i + 1];
                            if (0x8140 <= c && c <= 0x9FFC) c -= 0x8140;
                            else if (0xE040 <= c && c <= 0xEBBF) c -= 0xC140;
                            else throw "illegal char at " + (i + 1) + "/" + c;
                            c = (c >>> 8 & 0xff) * 0xC0 + (c & 0xff);
                            buffer.put(c, 13);
                            i += 2;
                        }
                        if (i < data.length) throw "illegal char at " + (i + 1);
                    };
                    return _this;
                };
                //=====================================================================
                // GIF Support etc.
                //
                //---------------------------------------------------------------------
                // byteArrayOutputStream
                //---------------------------------------------------------------------
                var byteArrayOutputStream = function() {
                    var _bytes = [];
                    var _this = {};
                    _this.writeByte = function(b) {
                        _bytes.push(b & 0xff);
                    };
                    _this.writeShort = function(i) {
                        _this.writeByte(i);
                        _this.writeByte(i >>> 8);
                    };
                    _this.writeBytes = function(b, off, len) {
                        off = off || 0;
                        len = len || b.length;
                        for(var i = 0; i < len; i += 1)_this.writeByte(b[i + off]);
                    };
                    _this.writeString = function(s) {
                        for(var i = 0; i < s.length; i += 1)_this.writeByte(s.charCodeAt(i));
                    };
                    _this.toByteArray = function() {
                        return _bytes;
                    };
                    _this.toString = function() {
                        var s = "";
                        s += "[";
                        for(var i = 0; i < _bytes.length; i += 1){
                            if (i > 0) s += ",";
                            s += _bytes[i];
                        }
                        s += "]";
                        return s;
                    };
                    return _this;
                };
                //---------------------------------------------------------------------
                // base64EncodeOutputStream
                //---------------------------------------------------------------------
                var base64EncodeOutputStream = function() {
                    var _buffer = 0;
                    var _buflen = 0;
                    var _length = 0;
                    var _base64 = "";
                    var _this = {};
                    var writeEncoded = function(b) {
                        _base64 += String.fromCharCode(encode(b & 0x3f));
                    };
                    var encode = function(n) {
                        if (n < 0) ;
                        else if (n < 26) return 0x41 + n;
                        else if (n < 52) return 0x61 + (n - 26);
                        else if (n < 62) return 0x30 + (n - 52);
                        else if (n == 62) return 0x2b;
                        else if (n == 63) return 0x2f;
                        throw "n:" + n;
                    };
                    _this.writeByte = function(n) {
                        _buffer = _buffer << 8 | n & 0xff;
                        _buflen += 8;
                        _length += 1;
                        while(_buflen >= 6){
                            writeEncoded(_buffer >>> _buflen - 6);
                            _buflen -= 6;
                        }
                    };
                    _this.flush = function() {
                        if (_buflen > 0) {
                            writeEncoded(_buffer << 6 - _buflen);
                            _buffer = 0;
                            _buflen = 0;
                        }
                        if (_length % 3 != 0) {
                            // padding
                            var padlen = 3 - _length % 3;
                            for(var i = 0; i < padlen; i += 1)_base64 += "=";
                        }
                    };
                    _this.toString = function() {
                        return _base64;
                    };
                    return _this;
                };
                //---------------------------------------------------------------------
                // base64DecodeInputStream
                //---------------------------------------------------------------------
                var base64DecodeInputStream = function(str) {
                    var _str = str;
                    var _pos = 0;
                    var _buffer = 0;
                    var _buflen = 0;
                    var _this = {};
                    _this.read = function() {
                        while(_buflen < 8){
                            if (_pos >= _str.length) {
                                if (_buflen == 0) return -1;
                                throw "unexpected end of file./" + _buflen;
                            }
                            var c = _str.charAt(_pos);
                            _pos += 1;
                            if (c == "=") {
                                _buflen = 0;
                                return -1;
                            } else if (c.match(/^\s$/)) continue;
                            _buffer = _buffer << 6 | decode(c.charCodeAt(0));
                            _buflen += 6;
                        }
                        var n = _buffer >>> _buflen - 8 & 0xff;
                        _buflen -= 8;
                        return n;
                    };
                    var decode = function(c) {
                        if (0x41 <= c && c <= 0x5a) return c - 0x41;
                        else if (0x61 <= c && c <= 0x7a) return c - 0x61 + 26;
                        else if (0x30 <= c && c <= 0x39) return c - 0x30 + 52;
                        else if (c == 0x2b) return 62;
                        else if (c == 0x2f) return 63;
                        else throw "c:" + c;
                    };
                    return _this;
                };
                //---------------------------------------------------------------------
                // gifImage (B/W)
                //---------------------------------------------------------------------
                var gifImage = function(width, height) {
                    var _width = width;
                    var _height = height;
                    var _data = new Array(width * height);
                    var _this = {};
                    _this.setPixel = function(x, y, pixel) {
                        _data[y * _width + x] = pixel;
                    };
                    _this.write = function(out) {
                        //---------------------------------
                        // GIF Signature
                        out.writeString("GIF87a");
                        //---------------------------------
                        // Screen Descriptor
                        out.writeShort(_width);
                        out.writeShort(_height);
                        out.writeByte(0x80); // 2bit
                        out.writeByte(0);
                        out.writeByte(0);
                        //---------------------------------
                        // Global Color Map
                        // black
                        out.writeByte(0x00);
                        out.writeByte(0x00);
                        out.writeByte(0x00);
                        // white
                        out.writeByte(0xff);
                        out.writeByte(0xff);
                        out.writeByte(0xff);
                        //---------------------------------
                        // Image Descriptor
                        out.writeString(",");
                        out.writeShort(0);
                        out.writeShort(0);
                        out.writeShort(_width);
                        out.writeShort(_height);
                        out.writeByte(0);
                        //---------------------------------
                        // Local Color Map
                        //---------------------------------
                        // Raster Data
                        var lzwMinCodeSize = 2;
                        var raster = getLZWRaster(lzwMinCodeSize);
                        out.writeByte(lzwMinCodeSize);
                        var offset = 0;
                        while(raster.length - offset > 255){
                            out.writeByte(255);
                            out.writeBytes(raster, offset, 255);
                            offset += 255;
                        }
                        out.writeByte(raster.length - offset);
                        out.writeBytes(raster, offset, raster.length - offset);
                        out.writeByte(0x00);
                        //---------------------------------
                        // GIF Terminator
                        out.writeString(";");
                    };
                    var bitOutputStream = function(out) {
                        var _out = out;
                        var _bitLength = 0;
                        var _bitBuffer = 0;
                        var _this = {};
                        _this.write = function(data, length) {
                            if (data >>> length != 0) throw "length over";
                            while(_bitLength + length >= 8){
                                _out.writeByte(0xff & (data << _bitLength | _bitBuffer));
                                length -= 8 - _bitLength;
                                data >>>= 8 - _bitLength;
                                _bitBuffer = 0;
                                _bitLength = 0;
                            }
                            _bitBuffer = data << _bitLength | _bitBuffer;
                            _bitLength = _bitLength + length;
                        };
                        _this.flush = function() {
                            if (_bitLength > 0) _out.writeByte(_bitBuffer);
                        };
                        return _this;
                    };
                    var getLZWRaster = function(lzwMinCodeSize) {
                        var clearCode = 1 << lzwMinCodeSize;
                        var endCode = (1 << lzwMinCodeSize) + 1;
                        var bitLength = lzwMinCodeSize + 1;
                        // Setup LZWTable
                        var table = lzwTable();
                        for(var i = 0; i < clearCode; i += 1)table.add(String.fromCharCode(i));
                        table.add(String.fromCharCode(clearCode));
                        table.add(String.fromCharCode(endCode));
                        var byteOut = byteArrayOutputStream();
                        var bitOut = bitOutputStream(byteOut);
                        // clear code
                        bitOut.write(clearCode, bitLength);
                        var dataIndex = 0;
                        var s = String.fromCharCode(_data[dataIndex]);
                        dataIndex += 1;
                        while(dataIndex < _data.length){
                            var c = String.fromCharCode(_data[dataIndex]);
                            dataIndex += 1;
                            if (table.contains(s + c)) s = s + c;
                            else {
                                bitOut.write(table.indexOf(s), bitLength);
                                if (table.size() < 0xfff) {
                                    if (table.size() == 1 << bitLength) bitLength += 1;
                                    table.add(s + c);
                                }
                                s = c;
                            }
                        }
                        bitOut.write(table.indexOf(s), bitLength);
                        // end code
                        bitOut.write(endCode, bitLength);
                        bitOut.flush();
                        return byteOut.toByteArray();
                    };
                    var lzwTable = function() {
                        var _map = {};
                        var _size = 0;
                        var _this = {};
                        _this.add = function(key) {
                            if (_this.contains(key)) throw "dup key:" + key;
                            _map[key] = _size;
                            _size += 1;
                        };
                        _this.size = function() {
                            return _size;
                        };
                        _this.indexOf = function(key) {
                            return _map[key];
                        };
                        _this.contains = function(key) {
                            return typeof _map[key] != "undefined";
                        };
                        return _this;
                    };
                    return _this;
                };
                var createDataURL = function(width, height, getPixel) {
                    var gif = gifImage(width, height);
                    for(var y = 0; y < height; y += 1)for(var x = 0; x < width; x += 1)gif.setPixel(x, y, getPixel(x, y));
                    var b = byteArrayOutputStream();
                    gif.write(b);
                    var base64 = base64EncodeOutputStream();
                    var bytes = b.toByteArray();
                    for(var i = 0; i < bytes.length; i += 1)base64.writeByte(bytes[i]);
                    base64.flush();
                    return "data:image/gif;base64," + base64;
                };
                //---------------------------------------------------------------------
                // returns qrcode function.
                return qrcode;
            }();
            // multibyte support
            !function() {
                qrcode.stringToBytesFuncs["UTF-8"] = function(s) {
                    // http://stackoverflow.com/questions/18729405/how-to-convert-utf8-string-to-byte-array
                    function toUTF8Array(str) {
                        var utf8 = [];
                        for(var i = 0; i < str.length; i++){
                            var charcode = str.charCodeAt(i);
                            if (charcode < 0x80) utf8.push(charcode);
                            else if (charcode < 0x800) utf8.push(0xc0 | charcode >> 6, 0x80 | charcode & 0x3f);
                            else if (charcode < 0xd800 || charcode >= 0xe000) utf8.push(0xe0 | charcode >> 12, 0x80 | charcode >> 6 & 0x3f, 0x80 | charcode & 0x3f);
                            else {
                                i++;
                                // UTF-16 encodes 0x10000-0x10FFFF by
                                // subtracting 0x10000 and splitting the
                                // 20 bits of 0x0-0xFFFFF into two halves
                                charcode = 0x10000 + ((charcode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
                                utf8.push(0xf0 | charcode >> 18, 0x80 | charcode >> 12 & 0x3f, 0x80 | charcode >> 6 & 0x3f, 0x80 | charcode & 0x3f);
                            }
                        }
                        return utf8;
                    }
                    return toUTF8Array(s);
                };
            }();
            (function(factory) {
                __WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function" ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module1.exports = __WEBPACK_AMD_DEFINE_RESULT__);
            })(function() {
                return qrcode;
            });
        /***/ }
    ]);
});

});

parcelRegister("bIfKR", function(module, exports) {

$parcel$export(module.exports, "initEmailOrPhoneInput", function () { return $75e8686edab4c564$export$f04c3e95927e9cce; });

/* Html like this should be for this module:
<div class="reg-form__input offset-m country-code-container">
    <input class="input input_width_m country-code-input" id="attendeeEmailOrPhoneNumber" type="text" placeholder="Your email" />
    <div class="country-code-selector" style="display:none;">
        <div class="country-code-selector__selected" data-code="US">US +1</div>
        <div class="country-code-selector__options">
<!--        <div class="country-code-selector__option" data-code="US">United States +1</div>-->
<!--        <div class="country-code-selector__option" data-code="AF">Afghanistan +93</div>-->
        </div>
    </div>
</div>
 */ // We are temporarily using this list until it’s enabled for everyone. Once that happens, the list can be sourced from the ./countryCodes.ts file.
const $75e8686edab4c564$var$COUNTRY_CODES = [
    {
        name: "United States",
        dialCode: "+1",
        code: "US"
    }
];
function $75e8686edab4c564$export$f04c3e95927e9cce({ defaultCode: defaultCode = $75e8686edab4c564$var$COUNTRY_CODES[0].code, placeholderOnlyEmail: placeholderOnlyEmail = "Your email", placeholderEmailOrPhone: placeholderEmailOrPhone = "Your email or US phone number" } = {}) {
    let cbOnChangeMode = (mode)=>{};
    const select = document.querySelector(".country-code-selector");
    const input = document.querySelector(".country-code-input");
    const selected = document.querySelector(".country-code-selector__selected");
    const options = document.querySelector(".country-code-selector__options");
    input.setAttribute("placeholder", placeholderOnlyEmail);
    setCountryCode(defaultCode);
    renderOptions($75e8686edab4c564$var$COUNTRY_CODES);
    if ($75e8686edab4c564$var$COUNTRY_CODES.length > 1) {
        select.addEventListener("click", ()=>{
            options.style.display = options.style.display === "block" ? "none" : "block";
        });
        options.addEventListener("click", (e)=>{
            var _e_target;
            const currentOption = (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.closest(".country-code-selector__option");
            if (currentOption) {
                const code = currentOption.getAttribute("data-code");
                if (code) {
                    setCountryCode(code);
                    updateInputPadding();
                }
            }
        });
        document.addEventListener("click", (e)=>{
            if (!select.contains(e.target)) options.style.display = "none";
        });
    }
    return {
        get: get,
        contentType: contentType,
        enablePhoneNumber: enablePhoneNumber,
        onChangeMode: (cb)=>{
            cbOnChangeMode = cb;
        }
    };
    function get() {
        if (isEnableCountryCode()) {
            const selectedCode = selected.getAttribute("data-code");
            if (!selectedCode) throw new Error("Country code is not found");
            const code = findCountryCodeByCode(selectedCode);
            if (!code) throw new Error("Country code is not found");
            return `${code.dialCode}${input.value}`.replace(/\s+/g, "");
        }
        return input.value.replace(/\s+/g, "");
    }
    function contentType() {
        const type = determineInputType(input.value);
        if (type === "phoneWithCountryCode" || type === "phoneWithoutCountryCode") return "phone";
        if (type === "email") return "email";
        return "";
    }
    function setCountryCode(code) {
        const countryCode = findCountryCodeByCode(code);
        if (countryCode) {
            selected.textContent = `${countryCode.code} ${countryCode.dialCode}`;
            selected.setAttribute("data-code", countryCode.code);
        }
    }
    function renderOptions(countryCodes) {
        const optionsHTML = countryCodes.map((item)=>`<div class="country-code-selector__option" data-code="${item.code}">${item.name} ${item.dialCode}</div>`).join("");
        options.innerHTML = optionsHTML;
    }
    function findCountryCodeByCode(code) {
        return $75e8686edab4c564$var$COUNTRY_CODES.find((item)=>item.code === code);
    }
    function updateInputPadding() {
        const width = selected.offsetWidth;
        input.style.paddingLeft = `${width}px`;
    }
    function removeInputPadding() {
        input.style.paddingLeft = "";
    }
    function showSelectCountryCode() {
        select.style.display = "block";
        updateInputPadding();
    }
    function hideSelectCountryCode() {
        select.style.display = "none";
        removeInputPadding();
    }
    function isEnableCountryCode() {
        return select.style.display === "block";
    }
    function determineInputType(value) {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const phoneWithCountryCodeRegex = /^\+\d[\d\s]*$/;
        const phoneWithoutCountryCodeRegex = /^\d[\d\s]*$/;
        if (phoneWithCountryCodeRegex.test(value)) return "phoneWithCountryCode";
        if (phoneWithoutCountryCodeRegex.test(value)) return "phoneWithoutCountryCode";
        if (emailRegex.test(value)) return "email";
        return "invalid";
    }
    function enablePhoneNumber() {
        let prevState = "";
        input.setAttribute("placeholder", placeholderEmailOrPhone);
        input.addEventListener("input", (e)=>{
            var _e_target;
            const inputType = determineInputType((_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value.trim());
            if (inputType !== prevState) {
                if (inputType === "phoneWithoutCountryCode") showSelectCountryCode();
                else hideSelectCountryCode();
                cbOnChangeMode(inputType);
                prevState = inputType;
            }
        });
    }
}

});

parcelRegister("2bCNn", function(module, exports) {

$parcel$export(module.exports, "validateSync", function () { return $eff4caa4eac572a6$export$4e387d0f532ac64f; });

var $auyQS = parcelRequire("auyQS");
function $eff4caa4eac572a6$export$4e387d0f532ac64f({ schema: schema, values: values, onError: onError, onSuccess: onSuccess }) {
    try {
        schema.validateSync(values, {
            abortEarly: false
        });
        onSuccess();
    } catch (err) {
        if (err instanceof $auyQS.ValidationError) onError(err);
        else throw err;
    }
}
async function $eff4caa4eac572a6$export$ec9e0a98ddb8e655({ schema: schema, values: values, onError: onError, onSuccess: onSuccess }) {
    try {
        await schema.validate(values, {
            abortEarly: false
        });
        onSuccess();
    } catch (err) {
        if (err instanceof $auyQS.ValidationError) onError(err);
        else throw err;
    }
}

});
parcelRegister("auyQS", function(module, exports) {

$parcel$export(module.exports, "ValidationError", function () { return $7a37bd8f106468a9$export$2191b9da168c6cf0; });
$parcel$export(module.exports, "string", function () { return $7a37bd8f106468a9$export$22b082955e083ec3; });
$parcel$export(module.exports, "object", function () { return $7a37bd8f106468a9$export$be5493f9613cbbe; });
$parcel$export(module.exports, "boolean", function () { return $7a37bd8f106468a9$export$87b259aa03e3d267; });

var $l6o43 = parcelRequire("l6o43");

var $7yUba = parcelRequire("7yUba");

var $hPrfq = parcelRequire("hPrfq");
const $7a37bd8f106468a9$var$toString = Object.prototype.toString;
const $7a37bd8f106468a9$var$errorToString = Error.prototype.toString;
const $7a37bd8f106468a9$var$regExpToString = RegExp.prototype.toString;
const $7a37bd8f106468a9$var$symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : ()=>"";
const $7a37bd8f106468a9$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $7a37bd8f106468a9$var$printNumber(val) {
    if (val != +val) return "NaN";
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? "-0" : "" + val;
}
function $7a37bd8f106468a9$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return "" + val;
    const typeOf = typeof val;
    if (typeOf === "number") return $7a37bd8f106468a9$var$printNumber(val);
    if (typeOf === "string") return quoteStrings ? `"${val}"` : val;
    if (typeOf === "function") return "[Function " + (val.name || "anonymous") + "]";
    if (typeOf === "symbol") return $7a37bd8f106468a9$var$symbolToString.call(val).replace($7a37bd8f106468a9$var$SYMBOL_REGEXP, "Symbol($1)");
    const tag = $7a37bd8f106468a9$var$toString.call(val).slice(8, -1);
    if (tag === "Date") return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
    if (tag === "Error" || val instanceof Error) return "[" + $7a37bd8f106468a9$var$errorToString.call(val) + "]";
    if (tag === "RegExp") return $7a37bd8f106468a9$var$regExpToString.call(val);
    return null;
}
function $7a37bd8f106468a9$export$5790025c6e6c2ba6(value, quoteStrings) {
    let result = $7a37bd8f106468a9$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $7a37bd8f106468a9$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}
function $7a37bd8f106468a9$var$toArray(value) {
    return value == null ? [] : [].concat(value);
}
let $7a37bd8f106468a9$var$_Symbol$toStringTag, $7a37bd8f106468a9$var$_Symbol$hasInstance, $7a37bd8f106468a9$var$_Symbol$toStringTag2;
let $7a37bd8f106468a9$var$strReg = /\$\{\s*(\w+)\s*\}/g;
$7a37bd8f106468a9$var$_Symbol$toStringTag = Symbol.toStringTag;
class $7a37bd8f106468a9$var$ValidationErrorNoStack {
    constructor(errorOrErrors, value, field, type){
        this.name = void 0;
        this.message = void 0;
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = void 0;
        this.inner = void 0;
        this[$7a37bd8f106468a9$var$_Symbol$toStringTag] = "Error";
        this.name = "ValidationError";
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        $7a37bd8f106468a9$var$toArray(errorOrErrors).forEach((err)=>{
            if ($7a37bd8f106468a9$export$2191b9da168c6cf0.isError(err)) {
                this.errors.push(...err.errors);
                const innerErrors = err.inner.length ? err.inner : [
                    err
                ];
                this.inner.push(...innerErrors);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    }
}
$7a37bd8f106468a9$var$_Symbol$hasInstance = Symbol.hasInstance;
$7a37bd8f106468a9$var$_Symbol$toStringTag2 = Symbol.toStringTag;
class $7a37bd8f106468a9$export$2191b9da168c6cf0 extends Error {
    static formatError(message, params) {
        // Attempt to make the path more friendly for error message interpolation.
        const path = params.label || params.path || "this";
        // Store the original path under `originalPath` so it isn't lost to custom
        // message functions; e.g., ones provided in `setLocale()` calls.
        params = Object.assign({}, params, {
            path: path,
            originalPath: params.path
        });
        if (typeof message === "string") return message.replace($7a37bd8f106468a9$var$strReg, (_, key)=>$7a37bd8f106468a9$export$5790025c6e6c2ba6(params[key]));
        if (typeof message === "function") return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === "ValidationError";
    }
    static [$7a37bd8f106468a9$var$_Symbol$hasInstance](inst) {
        return $7a37bd8f106468a9$var$ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
    }
    constructor(errorOrErrors, value, field, type, disableStack){
        const errorNoStack = new $7a37bd8f106468a9$var$ValidationErrorNoStack(errorOrErrors, value, field, type);
        if (disableStack) return errorNoStack;
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = [];
        this.inner = [];
        this[$7a37bd8f106468a9$var$_Symbol$toStringTag2] = "Error";
        this.name = errorNoStack.name;
        this.message = errorNoStack.message;
        this.type = errorNoStack.type;
        this.value = errorNoStack.value;
        this.path = errorNoStack.path;
        this.errors = errorNoStack.errors;
        this.inner = errorNoStack.inner;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $7a37bd8f106468a9$export$2191b9da168c6cf0);
    }
}
let $7a37bd8f106468a9$var$mixed = {
    default: "${path} is invalid",
    required: "${path} is a required field",
    defined: "${path} must be defined",
    notNull: "${path} cannot be null",
    oneOf: "${path} must be one of the following values: ${values}",
    notOneOf: "${path} must not be one of the following values: ${values}",
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${$7a37bd8f106468a9$export$5790025c6e6c2ba6(originalValue, true)}\`).` : ".";
        return type !== "mixed" ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${$7a37bd8f106468a9$export$5790025c6e6c2ba6(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${$7a37bd8f106468a9$export$5790025c6e6c2ba6(value, true)}\`` + castMsg;
    }
};
let $7a37bd8f106468a9$var$string = {
    length: "${path} must be exactly ${length} characters",
    min: "${path} must be at least ${min} characters",
    max: "${path} must be at most ${max} characters",
    matches: '${path} must match the following: "${regex}"',
    email: "${path} must be a valid email",
    url: "${path} must be a valid URL",
    uuid: "${path} must be a valid UUID",
    datetime: "${path} must be a valid ISO date-time",
    datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
    datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
    trim: "${path} must be a trimmed string",
    lowercase: "${path} must be a lowercase string",
    uppercase: "${path} must be a upper case string"
};
let $7a37bd8f106468a9$var$number = {
    min: "${path} must be greater than or equal to ${min}",
    max: "${path} must be less than or equal to ${max}",
    lessThan: "${path} must be less than ${less}",
    moreThan: "${path} must be greater than ${more}",
    positive: "${path} must be a positive number",
    negative: "${path} must be a negative number",
    integer: "${path} must be an integer"
};
let $7a37bd8f106468a9$var$date = {
    min: "${path} field must be later than ${min}",
    max: "${path} field must be at earlier than ${max}"
};
let $7a37bd8f106468a9$var$boolean = {
    isValue: "${path} field must be ${value}"
};
let $7a37bd8f106468a9$var$object = {
    noUnknown: "${path} field has unspecified keys: ${unknown}",
    exact: "${path} object contains unknown properties: ${properties}"
};
let $7a37bd8f106468a9$var$array = {
    min: "${path} field must have at least ${min} items",
    max: "${path} field must have less than or equal to ${max} items",
    length: "${path} must have ${length} items"
};
let $7a37bd8f106468a9$var$tuple = {
    notType: (params)=>{
        const { path: path, value: value, spec: spec } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
            if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${$7a37bd8f106468a9$export$5790025c6e6c2ba6(value, true)}\``;
            if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${$7a37bd8f106468a9$export$5790025c6e6c2ba6(value, true)}\``;
        }
        return $7a37bd8f106468a9$export$2191b9da168c6cf0.formatError($7a37bd8f106468a9$var$mixed.notType, params);
    }
};
var $7a37bd8f106468a9$export$d7f512c98c859244 = Object.assign(Object.create(null), {
    mixed: $7a37bd8f106468a9$var$mixed,
    string: $7a37bd8f106468a9$var$string,
    number: $7a37bd8f106468a9$var$number,
    date: $7a37bd8f106468a9$var$date,
    object: $7a37bd8f106468a9$var$object,
    array: $7a37bd8f106468a9$var$array,
    boolean: $7a37bd8f106468a9$var$boolean,
    tuple: $7a37bd8f106468a9$var$tuple
});
const $7a37bd8f106468a9$export$213e2a3e7c4f326e = (obj)=>obj && obj.__isYupSchema__;
class $7a37bd8f106468a9$var$Condition {
    static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
        let { is: is, then: then, otherwise: otherwise } = config;
        let check = typeof is === "function" ? is : (...values)=>values.every((value)=>value === is);
        return new $7a37bd8f106468a9$var$Condition(refs, (values, schema)=>{
            var _branch;
            let branch = check(...values) ? then : otherwise;
            return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>// TODO: ? operator here?
            ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined || // @ts-ignore this can be base
        schema === base) return base;
        if (!$7a37bd8f106468a9$export$213e2a3e7c4f326e(schema)) throw new TypeError("conditions must return a schema object");
        return schema.resolve(options);
    }
    constructor(refs, builder){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
    }
}
const $7a37bd8f106468a9$var$prefixes = {
    context: "$",
    value: "."
};
function $7a37bd8f106468a9$export$eff4d24c3ff7876e(key, options) {
    return new $7a37bd8f106468a9$var$Reference(key, options);
}
class $7a37bd8f106468a9$var$Reference {
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: "ref",
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== "string") throw new TypeError("ref must be a string, got: " + key);
        this.key = key.trim();
        if (key === "") throw new TypeError("ref must be a non-empty string");
        this.isContext = this.key[0] === $7a37bd8f106468a9$var$prefixes.context;
        this.isValue = this.key[0] === $7a37bd8f106468a9$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $7a37bd8f106468a9$var$prefixes.context : this.isValue ? $7a37bd8f106468a9$var$prefixes.value : "";
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $l6o43.getter)(this.path, true);
        this.map = options.map;
    }
}
// @ts-ignore
$7a37bd8f106468a9$var$Reference.prototype.__isYupRef = true;
const $7a37bd8f106468a9$var$isAbsent = (value)=>value == null;
function $7a37bd8f106468a9$var$createValidation(config) {
    function validate({ value: value, path: path = "", options: options, originalValue: originalValue, schema: schema }, panic, next) {
        const { name: name, test: test, params: params, message: message, skipAbsent: skipAbsent } = config;
        let { parent: parent, context: context, abortEarly: abortEarly = schema.spec.abortEarly, disableStackTrace: disableStackTrace = schema.spec.disableStackTrace } = options;
        function resolve(item) {
            return $7a37bd8f106468a9$var$Reference.isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = Object.assign({
                value: value,
                originalValue: originalValue,
                label: schema.spec.label,
                path: overrides.path || path,
                spec: schema.spec,
                disableStackTrace: overrides.disableStackTrace || disableStackTrace
            }, params, overrides.params);
            for (const key of Object.keys(nextParams))nextParams[key] = resolve(nextParams[key]);
            const error = new $7a37bd8f106468a9$export$2191b9da168c6cf0($7a37bd8f106468a9$export$2191b9da168c6cf0.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
            error.params = nextParams;
            return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
            path: path,
            parent: parent,
            type: name,
            from: options.from,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue,
            schema: schema
        };
        const handleResult = (validOrError)=>{
            if ($7a37bd8f106468a9$export$2191b9da168c6cf0.isError(validOrError)) invalid(validOrError);
            else if (!validOrError) invalid(createError());
            else next(null);
        };
        const handleError = (err)=>{
            if ($7a37bd8f106468a9$export$2191b9da168c6cf0.isError(err)) invalid(err);
            else panic(err);
        };
        const shouldSkip = skipAbsent && $7a37bd8f106468a9$var$isAbsent(value);
        if (shouldSkip) return handleResult(true);
        let result;
        try {
            var _result;
            result = test.call(ctx, value, ctx);
            if (typeof ((_result = result) == null ? void 0 : _result.then) === "function") {
                if (options.sync) throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
                return Promise.resolve(result).then(handleResult, handleError);
            }
        } catch (err) {
            handleError(err);
            return;
        }
        handleResult(result);
    }
    validate.OPTIONS = config;
    return validate;
}
function $7a37bd8f106468a9$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug;
    // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $l6o43.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        let isTuple = schema.type === "tuple";
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
            if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }
        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
function $7a37bd8f106468a9$export$cfedb76369cc7782(obj, path, value, context) {
    return $7a37bd8f106468a9$export$c52e5867d5879e24(obj, path, value, context).schema;
}
class $7a37bd8f106468a9$var$ReferenceSet extends Set {
    describe() {
        const description = [];
        for (const item of this.values())description.push($7a37bd8f106468a9$var$Reference.isRef(item) ? item.describe() : item);
        return description;
    }
    resolveAll(resolve) {
        let result = [];
        for (const item of this.values())result.push(resolve(item));
        return result;
    }
    clone() {
        return new $7a37bd8f106468a9$var$ReferenceSet(this.values());
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach((value)=>next.add(value));
        removeItems.forEach((value)=>next.delete(value));
        return next;
    }
}
// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function $7a37bd8f106468a9$var$clone(src, seen = new Map()) {
    if ($7a37bd8f106468a9$export$213e2a3e7c4f326e(src) || !src || typeof src !== "object") return src;
    if (seen.has(src)) return seen.get(src);
    let copy;
    if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
    } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
    } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for(let i = 0; i < src.length; i++)copy[i] = $7a37bd8f106468a9$var$clone(src[i], seen);
    } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries())copy.set(k, $7a37bd8f106468a9$var$clone(v, seen));
    } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src)copy.add($7a37bd8f106468a9$var$clone(v, seen));
    } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src))copy[k] = $7a37bd8f106468a9$var$clone(v, seen);
    } else throw Error(`Unable to clone ${src}`);
    return copy;
}
// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class $7a37bd8f106468a9$export$19342e026b58ebb7 {
    // TODO: remove
    get _type() {
        return this.type;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        }
        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));
        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);
        // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = $7a37bd8f106468a9$var$clone(Object.assign({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;
        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (v == null) {
            if (this.spec.nullable && v === null) return true;
            if (this.spec.optional && v === undefined) return true;
            return false;
        }
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((prevSchema, condition)=>condition.resolve(prevSchema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
            from: options.from || [],
            strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
            abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
            recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
            disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
    }
    /**
   * Run the configured transform pipeline over an input value.
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({
            value: value
        }, options));
        let allowOptionality = options.assert === "ignore-optionality";
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
            if (allowOptionality && $7a37bd8f106468a9$var$isAbsent(result)) return result;
            let formattedValue = $7a37bd8f106468a9$export$5790025c6e6c2ba6(value);
            let formattedResult = $7a37bd8f106468a9$export$5790025c6e6c2ba6(result);
            throw new TypeError(`The value of ${options.path || "field"} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
        }
        return result;
    }
    _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn)=>fn.call(this, prevValue, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault(options);
        return value;
    }
    _validate(_value, options = {}, panic, next) {
        let { path: path, originalValue: originalValue = _value, strict: strict = this.spec.strict } = options;
        let value = _value;
        if (!strict) value = this._cast(value, Object.assign({
            assert: false
        }, options));
        let initialTests = [];
        for (let test of Object.values(this.internalTests))if (test) initialTests.push(test);
        this.runTests({
            path: path,
            value: value,
            originalValue: originalValue,
            options: options,
            tests: initialTests
        }, panic, (initialErrors)=>{
            // even if we aren't ending early we can't proceed further if the types aren't correct
            if (initialErrors.length) return next(initialErrors, value);
            this.runTests({
                path: path,
                value: value,
                originalValue: originalValue,
                options: options,
                tests: this.tests
            }, panic, next);
        });
    }
    /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */ runTests(runOptions, panic, next) {
        let fired = false;
        let { tests: tests, value: value, originalValue: originalValue, path: path, options: options } = runOptions;
        let panicOnce = (arg)=>{
            if (fired) return;
            fired = true;
            panic(arg, value);
        };
        let nextOnce = (arg)=>{
            if (fired) return;
            fired = true;
            next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
            value: value,
            originalValue: originalValue,
            path: path,
            options: options,
            schema: this
        };
        for(let i = 0; i < tests.length; i++){
            const test = tests[i];
            test(args, panicOnce, function finishTestRun(err) {
                if (err) Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
                if (--count <= 0) nextOnce(nestedErrors);
            });
        }
    }
    asNestedTest({ key: key, index: index, parent: parent, parentPath: parentPath, originalParent: originalParent, options: options }) {
        const k = key != null ? key : index;
        if (k == null) throw TypeError("Must include `key` or `index` for nested validations");
        const isIndex = typeof k === "number";
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
            // Nested validations fields are always strict:
            //    1. parent isn't strict so the casting will also have cast inner values
            //    2. parent is strict in which case the nested values weren't cast either
            strict: true,
            parent: parent,
            value: value,
            originalValue: originalParent[k],
            // FIXME: tests depend on `index` being passed around deeply,
            //   we should not let the options.key/index bleed through
            key: undefined,
            // index: undefined,
            [isIndex ? "index" : "key"]: k,
            path: isIndex || k.includes(".") ? `${parentPath || ""}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : "") + key
        });
        return (_, panic, next)=>this.resolve(testOptions)._validate(value, testOptions, panic, next);
    }
    validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject)=>schema._validate(value, options, (error, parsed)=>{
                if ($7a37bd8f106468a9$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
                reject(error);
            }, (errors, validated)=>{
                if (errors.length) reject(new $7a37bd8f106468a9$export$2191b9da168c6cf0(errors, validated, undefined, undefined, disableStackTrace));
                else resolve(validated);
            }));
    }
    validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
            sync: true
        }), (error, parsed)=>{
            if ($7a37bd8f106468a9$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
            throw error;
        }, (errors, validated)=>{
            if (errors.length) throw new $7a37bd8f106468a9$export$2191b9da168c6cf0(errors, value, undefined, undefined, disableStackTrace);
            result = validated;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ($7a37bd8f106468a9$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ($7a37bd8f106468a9$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        }
    }
    _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === "function" ? defaultValue.call(this, options) : $7a37bd8f106468a9$var$clone(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        return this.clone({
            strict: isStrict
        });
    }
    nullability(nullable, message) {
        const next = this.clone({
            nullable: nullable
        });
        next.internalTests.nullable = $7a37bd8f106468a9$var$createValidation({
            message: message,
            name: "nullable",
            test (value) {
                return value === null ? this.schema.spec.nullable : true;
            }
        });
        return next;
    }
    optionality(optional, message) {
        const next = this.clone({
            optional: optional
        });
        next.internalTests.optionality = $7a37bd8f106468a9$var$createValidation({
            message: message,
            name: "optionality",
            test (value) {
                return value === undefined ? this.schema.spec.optional : true;
            }
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    defined(message = $7a37bd8f106468a9$var$mixed.defined) {
        return this.optionality(false, message);
    }
    nullable() {
        return this.nullability(true);
    }
    nonNullable(message = $7a37bd8f106468a9$var$mixed.notNull) {
        return this.nullability(false, message);
    }
    required(message = $7a37bd8f106468a9$var$mixed.required) {
        return this.clone().withMutation((next)=>next.nonNullable(message).defined(message));
    }
    notRequired() {
        return this.clone().withMutation((next)=>next.nullable().optional());
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === "function") opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = $7a37bd8f106468a9$var$mixed.default;
        if (typeof opts.test !== "function") throw new TypeError("`test` is a required parameters");
        let next = this.clone();
        let validate = $7a37bd8f106468a9$var$createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== "string") {
            options = keys;
            keys = ".";
        }
        let next = this.clone();
        let deps = $7a37bd8f106468a9$var$toArray(keys).map((key)=>new $7a37bd8f106468a9$var$Reference(key));
        deps.forEach((dep)=>{
            // @ts-ignore readonly array
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === "function" ? new $7a37bd8f106468a9$var$Condition(deps, options) : $7a37bd8f106468a9$var$Condition.fromOptions(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = $7a37bd8f106468a9$var$createValidation({
            message: message,
            name: "typeError",
            skipAbsent: true,
            test (value) {
                if (!this.schema._typeCheck(value)) return this.createError({
                    params: {
                        type: this.schema.type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = $7a37bd8f106468a9$var$mixed.oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next.internalTests.whiteList = $7a37bd8f106468a9$var$createValidation({
            message: message,
            name: "oneOf",
            skipAbsent: true,
            test (value) {
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: Array.from(valids).join(", "),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = $7a37bd8f106468a9$var$mixed.notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next.internalTests.blacklist = $7a37bd8f106468a9$var$createValidation({
            message: message,
            name: "notOneOf",
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: Array.from(invalids).join(", "),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */ describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const { label: label, meta: meta, optional: optional, nullable: nullable } = next.spec;
        const description = {
            meta: meta,
            label: label,
            optional: optional,
            nullable: nullable,
            default: next.getDefault(options),
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
    constructor(options){
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new $7a37bd8f106468a9$var$ReferenceSet();
        this._blacklist = new $7a37bd8f106468a9$var$ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError($7a37bd8f106468a9$var$mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            disableStackTrace: false,
            nullable: false,
            optional: true,
            coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation((s)=>{
            s.nonNullable();
        });
    }
}
// @ts-expect-error
$7a37bd8f106468a9$export$19342e026b58ebb7.prototype.__isYupSchema__ = true;
for (const method of [
    "validate",
    "validateSync"
])$7a37bd8f106468a9$export$19342e026b58ebb7.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = $7a37bd8f106468a9$export$c52e5867d5879e24(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    "equals",
    "is"
])$7a37bd8f106468a9$export$19342e026b58ebb7.prototype[alias] = $7a37bd8f106468a9$export$19342e026b58ebb7.prototype.oneOf;
for (const alias of [
    "not",
    "nope"
])$7a37bd8f106468a9$export$19342e026b58ebb7.prototype[alias] = $7a37bd8f106468a9$export$19342e026b58ebb7.prototype.notOneOf;
const $7a37bd8f106468a9$var$returnsTrue = ()=>true;
function $7a37bd8f106468a9$export$9b30b6294c1449a8(spec) {
    return new $7a37bd8f106468a9$export$1e88358c94ddec71(spec);
}
class $7a37bd8f106468a9$export$1e88358c94ddec71 extends $7a37bd8f106468a9$export$19342e026b58ebb7 {
    constructor(spec){
        super(typeof spec === "function" ? {
            type: "mixed",
            check: spec
        } : Object.assign({
            type: "mixed",
            check: $7a37bd8f106468a9$var$returnsTrue
        }, spec));
    }
}
$7a37bd8f106468a9$export$9b30b6294c1449a8.prototype = $7a37bd8f106468a9$export$1e88358c94ddec71.prototype;
function $7a37bd8f106468a9$export$87b259aa03e3d267() {
    return new $7a37bd8f106468a9$export$c7980688f11e1f49();
}
class $7a37bd8f106468a9$export$c7980688f11e1f49 extends $7a37bd8f106468a9$export$19342e026b58ebb7 {
    isTrue(message = $7a37bd8f106468a9$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "true"
            },
            test (value) {
                return $7a37bd8f106468a9$var$isAbsent(value) || value === true;
            }
        });
    }
    isFalse(message = $7a37bd8f106468a9$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "false"
            },
            test (value) {
                return $7a37bd8f106468a9$var$isAbsent(value) || value === false;
            }
        });
    }
    default(def) {
        return super.default(def);
    }
    defined(msg) {
        return super.defined(msg);
    }
    optional() {
        return super.optional();
    }
    required(msg) {
        return super.required(msg);
    }
    notRequired() {
        return super.notRequired();
    }
    nullable() {
        return super.nullable();
    }
    nonNullable(msg) {
        return super.nonNullable(msg);
    }
    strip(v) {
        return super.strip(v);
    }
    constructor(){
        super({
            type: "boolean",
            check (v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === "boolean";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (ctx.spec.coerce && !ctx.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
}
$7a37bd8f106468a9$export$87b259aa03e3d267.prototype = $7a37bd8f106468a9$export$c7980688f11e1f49.prototype;
/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ // prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const $7a37bd8f106468a9$var$isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $7a37bd8f106468a9$var$parseIsoDate(date) {
    const struct = $7a37bd8f106468a9$var$parseDateStruct(date);
    if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;
    // timestamps without timezone identifiers should be considered local time
    if (struct.z === undefined && struct.plusMinus === undefined) return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
    let totalMinutesOffset = 0;
    if (struct.z !== "Z" && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === "+") totalMinutesOffset = 0 - totalMinutesOffset;
    }
    return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function $7a37bd8f106468a9$var$parseDateStruct(date) {
    var _regexResult$7$length, _regexResult$;
    const regexResult = $7a37bd8f106468a9$var$isoReg.exec(date);
    if (!regexResult) return null;
    // use of toNumber() avoids NaN timestamps caused by “undefined”
    // values being passed to Date constructor
    return {
        year: $7a37bd8f106468a9$var$toNumber(regexResult[1]),
        month: $7a37bd8f106468a9$var$toNumber(regexResult[2], 1) - 1,
        day: $7a37bd8f106468a9$var$toNumber(regexResult[3], 1),
        hour: $7a37bd8f106468a9$var$toNumber(regexResult[4]),
        minute: $7a37bd8f106468a9$var$toNumber(regexResult[5]),
        second: $7a37bd8f106468a9$var$toNumber(regexResult[6]),
        millisecond: regexResult[7] ? // allow arbitrary sub-second precision beyond milliseconds
        $7a37bd8f106468a9$var$toNumber(regexResult[7].substring(0, 3)) : 0,
        precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: $7a37bd8f106468a9$var$toNumber(regexResult[10]),
        minuteOffset: $7a37bd8f106468a9$var$toNumber(regexResult[11])
    };
}
function $7a37bd8f106468a9$var$toNumber(str, defaultValue = 0) {
    return Number(str) || defaultValue;
}
// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let $7a37bd8f106468a9$var$rEmail = // eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let $7a37bd8f106468a9$var$rUrl = // eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
// eslint-disable-next-line
let $7a37bd8f106468a9$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $7a37bd8f106468a9$var$yearMonthDay = "^\\d{4}-\\d{2}-\\d{2}";
let $7a37bd8f106468a9$var$hourMinuteSecond = "\\d{2}:\\d{2}:\\d{2}";
let $7a37bd8f106468a9$var$zOrOffset = "(([+-]\\d{2}(:?\\d{2})?)|Z)";
let $7a37bd8f106468a9$var$rIsoDateTime = new RegExp(`${$7a37bd8f106468a9$var$yearMonthDay}T${$7a37bd8f106468a9$var$hourMinuteSecond}(\\.\\d+)?${$7a37bd8f106468a9$var$zOrOffset}$`);
let $7a37bd8f106468a9$var$isTrimmed = (value)=>$7a37bd8f106468a9$var$isAbsent(value) || value === value.trim();
let $7a37bd8f106468a9$var$objStringTag = ({}).toString();
function $7a37bd8f106468a9$export$22b082955e083ec3() {
    return new $7a37bd8f106468a9$export$49bf8b2ede5138eb();
}
class $7a37bd8f106468a9$export$49bf8b2ede5138eb extends $7a37bd8f106468a9$export$19342e026b58ebb7 {
    required(message) {
        return super.required(message).withMutation((schema)=>schema.test({
                message: message || $7a37bd8f106468a9$var$mixed.required,
                name: "required",
                skipAbsent: true,
                test: (value)=>!!value.length
            }));
    }
    notRequired() {
        return super.notRequired().withMutation((schema)=>{
            schema.tests = schema.tests.filter((t)=>t.OPTIONS.name !== "required");
            return schema;
        });
    }
    length(length, message = $7a37bd8f106468a9$var$string.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message = $7a37bd8f106468a9$var$string.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = $7a37bd8f106468a9$var$string.max) {
        return this.test({
            name: "max",
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === "object") ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || "matches",
            message: message || $7a37bd8f106468a9$var$string.matches,
            params: {
                regex: regex
            },
            skipAbsent: true,
            test: (value)=>value === "" && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = $7a37bd8f106468a9$var$string.email) {
        return this.matches($7a37bd8f106468a9$var$rEmail, {
            name: "email",
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = $7a37bd8f106468a9$var$string.url) {
        return this.matches($7a37bd8f106468a9$var$rUrl, {
            name: "url",
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = $7a37bd8f106468a9$var$string.uuid) {
        return this.matches($7a37bd8f106468a9$var$rUUID, {
            name: "uuid",
            message: message,
            excludeEmptyString: false
        });
    }
    datetime(options) {
        let message = "";
        let allowOffset;
        let precision;
        if (options) {
            if (typeof options === "object") ({ message: message = "", allowOffset: allowOffset = false, precision: precision } = options);
            else message = options;
        }
        return this.matches($7a37bd8f106468a9$var$rIsoDateTime, {
            name: "datetime",
            message: message || $7a37bd8f106468a9$var$string.datetime,
            excludeEmptyString: true
        }).test({
            name: "datetime_offset",
            message: message || $7a37bd8f106468a9$var$string.datetime_offset,
            params: {
                allowOffset: allowOffset
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || allowOffset) return true;
                const struct = $7a37bd8f106468a9$var$parseDateStruct(value);
                if (!struct) return false;
                return !!struct.z;
            }
        }).test({
            name: "datetime_precision",
            message: message || $7a37bd8f106468a9$var$string.datetime_precision,
            params: {
                precision: precision
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || precision == undefined) return true;
                const struct = $7a37bd8f106468a9$var$parseDateStruct(value);
                if (!struct) return false;
                return struct.precision === precision;
            }
        });
    }
    //-- transforms --
    ensure() {
        return this.default("").transform((val)=>val === null ? "" : val);
    }
    trim(message = $7a37bd8f106468a9$var$string.trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: "trim",
            test: $7a37bd8f106468a9$var$isTrimmed
        });
    }
    lowercase(message = $7a37bd8f106468a9$var$string.lowercase) {
        return this.transform((value)=>!$7a37bd8f106468a9$var$isAbsent(value) ? value.toLowerCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$7a37bd8f106468a9$var$isAbsent(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = $7a37bd8f106468a9$var$string.uppercase) {
        return this.transform((value)=>!$7a37bd8f106468a9$var$isAbsent(value) ? value.toUpperCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$7a37bd8f106468a9$var$isAbsent(value) || value === value.toUpperCase()
        });
    }
    constructor(){
        super({
            type: "string",
            check (value) {
                if (value instanceof String) value = value.valueOf();
                return typeof value === "string";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce || ctx.isType(value)) return value;
                // don't ever convert arrays
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                // no one wants plain objects converted to [Object object]
                if (strValue === $7a37bd8f106468a9$var$objStringTag) return value;
                return strValue;
            });
        });
    }
}
$7a37bd8f106468a9$export$22b082955e083ec3.prototype = $7a37bd8f106468a9$export$49bf8b2ede5138eb.prototype;
//
// String Interfaces
//
let $7a37bd8f106468a9$var$isNaN$1 = (value)=>value != +value;
function $7a37bd8f106468a9$export$98e628dec113755e() {
    return new $7a37bd8f106468a9$export$f192ec5e9228ab19();
}
class $7a37bd8f106468a9$export$f192ec5e9228ab19 extends $7a37bd8f106468a9$export$19342e026b58ebb7 {
    min(min, message = $7a37bd8f106468a9$var$number.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(min);
            }
        });
    }
    max(max, message = $7a37bd8f106468a9$var$number.max) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = $7a37bd8f106468a9$var$number.lessThan) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                less: less
            },
            skipAbsent: true,
            test (value) {
                return value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = $7a37bd8f106468a9$var$number.moreThan) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                more: more
            },
            skipAbsent: true,
            test (value) {
                return value > this.resolve(more);
            }
        });
    }
    positive(msg = $7a37bd8f106468a9$var$number.positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = $7a37bd8f106468a9$var$number.negative) {
        return this.lessThan(0, msg);
    }
    integer(message = $7a37bd8f106468a9$var$number.integer) {
        return this.test({
            name: "integer",
            message: message,
            skipAbsent: true,
            test: (val)=>Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!$7a37bd8f106468a9$var$isAbsent(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            "ceil",
            "floor",
            "round",
            "trunc"
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || "round";
        // this exists for symemtry with the new Math.trunc
        if (method === "trunc") return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + avail.join(", "));
        return this.transform((value)=>!$7a37bd8f106468a9$var$isAbsent(value) ? Math[method](value) : value);
    }
    constructor(){
        super({
            type: "number",
            check (value) {
                if (value instanceof Number) value = value.valueOf();
                return typeof value === "number" && !$7a37bd8f106468a9$var$isNaN$1(value);
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce) return value;
                let parsed = value;
                if (typeof parsed === "string") {
                    parsed = parsed.replace(/\s/g, "");
                    if (parsed === "") return NaN;
                    // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                // null -> NaN isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (ctx.isType(parsed) || parsed === null) return parsed;
                return parseFloat(parsed);
            });
        });
    }
}
$7a37bd8f106468a9$export$98e628dec113755e.prototype = $7a37bd8f106468a9$export$f192ec5e9228ab19.prototype;
//
// Number Interfaces
//
let $7a37bd8f106468a9$var$invalidDate = new Date("");
let $7a37bd8f106468a9$var$isDate = (obj)=>Object.prototype.toString.call(obj) === "[object Date]";
function $7a37bd8f106468a9$export$324d90190a8b822a() {
    return new $7a37bd8f106468a9$export$18ec3cc5a157503f();
}
class $7a37bd8f106468a9$export$18ec3cc5a157503f extends $7a37bd8f106468a9$export$19342e026b58ebb7 {
    prepareParam(ref, name) {
        let param;
        if (!$7a37bd8f106468a9$var$Reference.isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = $7a37bd8f106468a9$var$date.min) {
        let limit = this.prepareParam(min, "min");
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(limit);
            }
        });
    }
    max(max, message = $7a37bd8f106468a9$var$date.max) {
        let limit = this.prepareParam(max, "max");
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(limit);
            }
        });
    }
    constructor(){
        super({
            type: "date",
            check (v) {
                return $7a37bd8f106468a9$var$isDate(v) && !isNaN(v.getTime());
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
                value = $7a37bd8f106468a9$var$parseIsoDate(value);
                // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $7a37bd8f106468a9$export$18ec3cc5a157503f.INVALID_DATE;
            });
        });
    }
}
$7a37bd8f106468a9$export$18ec3cc5a157503f.INVALID_DATE = $7a37bd8f106468a9$var$invalidDate;
$7a37bd8f106468a9$export$324d90190a8b822a.prototype = $7a37bd8f106468a9$export$18ec3cc5a157503f.prototype;
$7a37bd8f106468a9$export$324d90190a8b822a.INVALID_DATE = $7a37bd8f106468a9$var$invalidDate;
// @ts-expect-error
function $7a37bd8f106468a9$var$sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $l6o43.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for (const key of Object.keys(fields)){
        let value = fields[key];
        nodes.add(key);
        if ($7a37bd8f106468a9$var$Reference.isRef(value) && value.isSibling) addNode(value.path, key);
        else if ($7a37bd8f106468a9$export$213e2a3e7c4f326e(value) && "deps" in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($hPrfq))).array(Array.from(nodes), edges).reverse();
}
function $7a37bd8f106468a9$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $7a37bd8f106468a9$var$sortByKeyOrder(keys) {
    return (a, b)=>{
        return $7a37bd8f106468a9$var$findIndex(keys, a) - $7a37bd8f106468a9$var$findIndex(keys, b);
    };
}
const $7a37bd8f106468a9$var$parseJson = (value, _, ctx)=>{
    if (typeof value !== "string") return value;
    let parsed = value;
    try {
        parsed = JSON.parse(value);
    } catch (err) {
    /* */ }
    return ctx.isType(parsed) ? parsed : value;
};
// @ts-ignore
function $7a37bd8f106468a9$var$deepPartial(schema) {
    if ("fields" in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields))partial[key] = $7a37bd8f106468a9$var$deepPartial(fieldSchema);
        return schema.setFields(partial);
    }
    if (schema.type === "array") {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = $7a37bd8f106468a9$var$deepPartial(nextArray.innerType);
        return nextArray;
    }
    if (schema.type === "tuple") return schema.optional().clone({
        types: schema.spec.types.map($7a37bd8f106468a9$var$deepPartial)
    });
    if ("optional" in schema) return schema.optional();
    return schema;
}
const $7a37bd8f106468a9$var$deepHas = (obj, p)=>{
    const path = [
        ...(0, $l6o43.normalizePath)(p)
    ];
    if (path.length === 1) return path[0] in obj;
    let last = path.pop();
    let parent = (0, $l6o43.getter)((0, $l6o43.join)(path), true)(obj);
    return !!(parent && last in parent);
};
let $7a37bd8f106468a9$var$isObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]";
function $7a37bd8f106468a9$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $7a37bd8f106468a9$var$defaultSort = $7a37bd8f106468a9$var$sortByKeyOrder([]);
function $7a37bd8f106468a9$export$be5493f9613cbbe(spec) {
    return new $7a37bd8f106468a9$export$18b4fc70ec7eccf8(spec);
}
class $7a37bd8f106468a9$export$18b4fc70ec7eccf8 extends $7a37bd8f106468a9$export$19342e026b58ebb7 {
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);
        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter((v)=>!this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = prop in value;
            if (field) {
                let fieldValue;
                let inputValue = value[prop];
                // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : "") + prop;
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = field instanceof $7a37bd8f106468a9$export$19342e026b58ebb7 ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec != null && fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
                field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, options = {}, panic, next) {
        let { from: from = [], originalValue: originalValue = _value, recursive: recursive = this.spec.recursive } = options;
        options.from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value)=>{
            if (!recursive || !$7a37bd8f106468a9$var$isObject(value)) {
                next(objectErrors, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = [];
            for (let key of this._nodes){
                let field = this.fields[key];
                if (!field || $7a37bd8f106468a9$var$Reference.isRef(field)) continue;
                tests.push(field.asNestedTest({
                    options: options,
                    key: key,
                    parent: value,
                    parentPath: options.path,
                    originalParent: originalValue
                }));
            }
            this.runTests({
                tests: tests,
                value: value,
                originalValue: originalValue,
                options: options
            }, panic, (fieldErrors)=>{
                next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
            });
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation((s)=>// XXX: excludes here is wrong
            s.setFields(nextFields, [
                ...this._excludedEdges,
                ...schema._excludedEdges
            ]));
    }
    _getDefault(options) {
        if ("default" in this.spec) return super._getDefault(options);
        // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        let dft = {};
        this._nodes.forEach((key)=>{
            var _innerOptions;
            const field = this.fields[key];
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            dft[key] = field && "getDefault" in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
    }
    setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = $7a37bd8f106468a9$var$sortFields(shape, excludedEdges);
        next._sortErrors = $7a37bd8f106468a9$var$sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
    }
    shape(additions, excludes = []) {
        return this.clone().withMutation((next)=>{
            let edges = next._excludedEdges;
            if (excludes.length) {
                if (!Array.isArray(excludes[0])) excludes = [
                    excludes
                ];
                edges = [
                    ...next._excludedEdges,
                    ...excludes
                ];
            }
            // XXX: excludes here is wrong
            return next.setFields(Object.assign(next.fields, additions), edges);
        });
    }
    partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields))partial[key] = "optional" in schema && schema.optional instanceof Function ? schema.optional() : schema;
        return this.setFields(partial);
    }
    deepPartial() {
        const next = $7a37bd8f106468a9$var$deepPartial(this);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.setFields(picked, this._excludedEdges.filter(([a, b])=>keys.includes(a) && keys.includes(b)));
    }
    omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)){
            if (keys.includes(key)) continue;
            remaining.push(key);
        }
        return this.pick(remaining);
    }
    from(from, to, alias) {
        let fromGetter = (0, $l6o43.getter)(from, true);
        return this.transform((obj)=>{
            if (!obj) return obj;
            let newObj = obj;
            if ($7a37bd8f106468a9$var$deepHas(obj, from)) {
                newObj = Object.assign({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($7a37bd8f106468a9$var$parseJson);
    }
    /**
   * Similar to `noUnknown` but only validates that an object is the right shape without stripping the unknown keys
   */ exact(message) {
        return this.test({
            name: "exact",
            exclusive: true,
            message: message || $7a37bd8f106468a9$var$object.exact,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $7a37bd8f106468a9$var$unknown(this.schema, value);
                return unknownKeys.length === 0 || this.createError({
                    params: {
                        properties: unknownKeys.join(", ")
                    }
                });
            }
        });
    }
    stripUnknown() {
        return this.clone({
            noUnknown: true
        });
    }
    noUnknown(noAllow = true, message = $7a37bd8f106468a9$var$object.noUnknown) {
        if (typeof noAllow !== "boolean") {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: "noUnknown",
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $7a37bd8f106468a9$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(", ")
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = $7a37bd8f106468a9$var$object.noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>{
            if (!obj) return obj;
            const result = {};
            for (const key of Object.keys(obj))result[fn(key)] = obj[key];
            return result;
        });
    }
    camelCase() {
        return this.transformKeys((0, $7yUba.camelCase));
    }
    snakeCase() {
        return this.transformKeys((0, $7yUba.snakeCase));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, $7yUba.snakeCase)(key).toUpperCase());
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)){
            var _innerOptions2;
            let innerOptions = options;
            if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            base.fields[key] = value.describe(innerOptions);
        }
        return base;
    }
    constructor(spec){
        super({
            type: "object",
            check (value) {
                return $7a37bd8f106468a9$var$isObject(value) || typeof value === "function";
            }
        });
        this.fields = Object.create(null);
        this._sortErrors = $7a37bd8f106468a9$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            if (spec) this.shape(spec);
        });
    }
}
$7a37bd8f106468a9$export$be5493f9613cbbe.prototype = $7a37bd8f106468a9$export$18b4fc70ec7eccf8.prototype;
function $7a37bd8f106468a9$export$2f23118c22fb2630(type) {
    return new $7a37bd8f106468a9$export$4347112b8447a7d(type);
}
class $7a37bd8f106468a9$export$4347112b8447a7d extends $7a37bd8f106468a9$export$19342e026b58ebb7 {
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts);
        // should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
                path: `${_opts.path || ""}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        var _options$recursive;
        // let sync = options.sync;
        // let path = options.path;
        let innerType = this.innerType;
        // let endEarly = options.abortEarly ?? this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, panic, (arrayErrors, value)=>{
            var _options$originalValu2;
            if (!recursive || !innerType || !this._typeCheck(value)) {
                next(arrayErrors, value);
                return;
            }
            // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let index = 0; index < value.length; index++){
                var _options$originalValu;
                tests[index] = innerType.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(arrayErrors), value));
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        return next;
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($7a37bd8f106468a9$var$parseJson);
    }
    concat(schema) {
        let next = super.concat(schema);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        if (schema.innerType) // @ts-expect-error readonly
        next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!$7a37bd8f106468a9$export$213e2a3e7c4f326e(schema)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + $7a37bd8f106468a9$export$5790025c6e6c2ba6(schema));
        // @ts-expect-error readonly
        next.innerType = schema;
        next.spec = Object.assign({}, next.spec, {
            types: schema
        });
        return next;
    }
    length(length, message = $7a37bd8f106468a9$var$array.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || $7a37bd8f106468a9$var$array.min;
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            // FIXME(ts): Array<typeof T>
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || $7a37bd8f106468a9$var$array.max;
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        if (next.innerType) {
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[0]
            });
            base.innerType = next.innerType.describe(innerOptions);
        }
        return base;
    }
    constructor(type){
        super({
            type: "array",
            spec: {
                types: type
            },
            check (v) {
                return Array.isArray(v);
            }
        });
        // `undefined` specifically means uninitialized, as opposed to "no subtype"
        this.innerType = void 0;
        this.innerType = type;
    }
}
$7a37bd8f106468a9$export$2f23118c22fb2630.prototype = $7a37bd8f106468a9$export$4347112b8447a7d.prototype;
// @ts-ignore
function $7a37bd8f106468a9$export$65e3907585753458(schemas) {
    return new $7a37bd8f106468a9$export$411c3b3687e8ecc8(schemas);
}
class $7a37bd8f106468a9$export$411c3b3687e8ecc8 extends $7a37bd8f106468a9$export$19342e026b58ebb7 {
    _cast(inputValue, options) {
        const { types: types } = this.spec;
        const value = super._cast(inputValue, options);
        if (!this._typeCheck(value)) return value;
        let isChanged = false;
        const castArray = types.map((type, idx)=>{
            const castElement = type.cast(value[idx], Object.assign({}, options, {
                path: `${options.path || ""}[${idx}]`
            }));
            if (castElement !== value[idx]) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        let itemTypes = this.spec.types;
        super._validate(_value, options, panic, (tupleErrors, value)=>{
            var _options$originalValu2;
            // intentionally not respecting recursive
            if (!this._typeCheck(value)) {
                next(tupleErrors, value);
                return;
            }
            let tests = [];
            for (let [index, itemSchema] of itemTypes.entries()){
                var _options$originalValu;
                tests[index] = itemSchema.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(tupleErrors), value));
        });
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.innerType = next.spec.types.map((schema, index)=>{
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[index]
            });
            return schema.describe(innerOptions);
        });
        return base;
    }
    constructor(schemas){
        super({
            type: "tuple",
            spec: {
                types: schemas
            },
            check (v) {
                const types = this.spec.types;
                return Array.isArray(v) && v.length === types.length;
            }
        });
        this.withMutation(()=>{
            this.typeError($7a37bd8f106468a9$var$tuple.notType);
        });
    }
}
$7a37bd8f106468a9$export$65e3907585753458.prototype = $7a37bd8f106468a9$export$411c3b3687e8ecc8.prototype;
function $7a37bd8f106468a9$export$488013bae63b21da(builder) {
    return new $7a37bd8f106468a9$var$Lazy(builder);
}
class $7a37bd8f106468a9$var$Lazy {
    clone(spec) {
        const next = new $7a37bd8f106468a9$var$Lazy(this.builder);
        next.spec = Object.assign({}, this.spec, spec);
        return next;
    }
    optionality(optional) {
        const next = this.clone({
            optional: optional
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    asNestedTest(config) {
        let { key: key, index: index, parent: parent, options: options } = config;
        let value = parent[index != null ? index : key];
        return this._resolve(value, Object.assign({}, options, {
            value: value,
            parent: parent
        })).asNestedTest(config);
    }
    validate(value, options) {
        return this._resolve(value, options).validate(value, options);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    describe(options) {
        return options ? this.resolve(options).describe(options) : {
            type: "lazy",
            meta: this.spec.meta,
            label: undefined
        };
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    constructor(builder){
        this.type = "lazy";
        this.__isYupSchema__ = true;
        this.spec = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!$7a37bd8f106468a9$export$213e2a3e7c4f326e(schema)) throw new TypeError("lazy() functions must return a valid schema");
            if (this.spec.optional) schema = schema.optional();
            return schema.resolve(options);
        };
        this.builder = builder;
        this.spec = {
            meta: undefined,
            optional: false
        };
    }
}
function $7a37bd8f106468a9$export$c8aadf3621e41efb(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            $7a37bd8f106468a9$export$d7f512c98c859244[type][method] = custom[type][method];
        });
    });
}
function $7a37bd8f106468a9$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !$7a37bd8f106468a9$export$213e2a3e7c4f326e(schemaType.prototype)) throw new TypeError("You must provide a yup schema constructor function");
    if (typeof name !== "string") throw new TypeError("A Method name must be provided");
    if (typeof fn !== "function") throw new TypeError("Method function must be provided");
    schemaType.prototype[name] = fn;
}

});
parcelRegister("l6o43", function(module, exports) {
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ "use strict";
function $f5ccd3321436b317$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$f5ccd3321436b317$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$f5ccd3321436b317$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$f5ccd3321436b317$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $f5ccd3321436b317$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $f5ccd3321436b317$var$DIGIT_REGEX = /^\d+$/, $f5ccd3321436b317$var$LEAD_DIGIT_REGEX = /^\d/, $f5ccd3321436b317$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $f5ccd3321436b317$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $f5ccd3321436b317$var$MAX_CACHE_SIZE = 512;
var $f5ccd3321436b317$var$pathCache = new $f5ccd3321436b317$var$Cache($f5ccd3321436b317$var$MAX_CACHE_SIZE), $f5ccd3321436b317$var$setCache = new $f5ccd3321436b317$var$Cache($f5ccd3321436b317$var$MAX_CACHE_SIZE), $f5ccd3321436b317$var$getCache = new $f5ccd3321436b317$var$Cache($f5ccd3321436b317$var$MAX_CACHE_SIZE);
var $f5ccd3321436b317$var$config;
module.exports = {
    Cache: $f5ccd3321436b317$var$Cache,
    split: $f5ccd3321436b317$var$split,
    normalizePath: $f5ccd3321436b317$var$normalizePath,
    setter: function(path) {
        var parts = $f5ccd3321436b317$var$normalizePath(path);
        return $f5ccd3321436b317$var$setCache.get(path) || $f5ccd3321436b317$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === "__proto__" || part === "constructor" || part === "prototype") return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $f5ccd3321436b317$var$normalizePath(path);
        return $f5ccd3321436b317$var$getCache.get(path) || $f5ccd3321436b317$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($f5ccd3321436b317$var$isQuoted(part) || $f5ccd3321436b317$var$DIGIT_REGEX.test(part) ? "[" + part + "]" : (path ? "." : "") + part);
        }, "");
    },
    forEach: function(path, cb, thisArg) {
        $f5ccd3321436b317$var$forEach(Array.isArray(path) ? path : $f5ccd3321436b317$var$split(path), cb, thisArg);
    }
};
function $f5ccd3321436b317$var$normalizePath(path) {
    return $f5ccd3321436b317$var$pathCache.get(path) || $f5ccd3321436b317$var$pathCache.set(path, $f5ccd3321436b317$var$split(path).map(function(part) {
        return part.replace($f5ccd3321436b317$var$CLEAN_QUOTES_REGEX, "$2");
    }));
}
function $f5ccd3321436b317$var$split(path) {
    return path.match($f5ccd3321436b317$var$SPLIT_REGEX) || [
        ""
    ];
}
function $f5ccd3321436b317$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($f5ccd3321436b317$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $f5ccd3321436b317$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $f5ccd3321436b317$var$isQuoted(str) {
    return typeof str === "string" && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $f5ccd3321436b317$var$hasLeadingNumber(part) {
    return part.match($f5ccd3321436b317$var$LEAD_DIGIT_REGEX) && !part.match($f5ccd3321436b317$var$DIGIT_REGEX);
}
function $f5ccd3321436b317$var$hasSpecialChars(part) {
    return $f5ccd3321436b317$var$SPEC_CHAR_REGEX.test(part);
}
function $f5ccd3321436b317$var$shouldBeQuoted(part) {
    return !$f5ccd3321436b317$var$isQuoted(part) && ($f5ccd3321436b317$var$hasLeadingNumber(part) || $f5ccd3321436b317$var$hasSpecialChars(part));
}

});

parcelRegister("7yUba", function(module, exports) {
const $581749630132f166$var$reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const $581749630132f166$var$words = (str)=>str.match($581749630132f166$var$reWords) || [];
const $581749630132f166$var$upperFirst = (str)=>str[0].toUpperCase() + str.slice(1);
const $581749630132f166$var$join = (str, d)=>$581749630132f166$var$words(str).join(d).toLowerCase();
const $581749630132f166$var$camelCase = (str)=>$581749630132f166$var$words(str).reduce((acc, next)=>`${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, "");
const $581749630132f166$var$pascalCase = (str)=>$581749630132f166$var$upperFirst($581749630132f166$var$camelCase(str));
const $581749630132f166$var$snakeCase = (str)=>$581749630132f166$var$join(str, "_");
const $581749630132f166$var$kebabCase = (str)=>$581749630132f166$var$join(str, "-");
const $581749630132f166$var$sentenceCase = (str)=>$581749630132f166$var$upperFirst($581749630132f166$var$join(str, " "));
const $581749630132f166$var$titleCase = (str)=>$581749630132f166$var$words(str).map($581749630132f166$var$upperFirst).join(" ");
module.exports = {
    words: $581749630132f166$var$words,
    upperFirst: $581749630132f166$var$upperFirst,
    camelCase: $581749630132f166$var$camelCase,
    pascalCase: $581749630132f166$var$pascalCase,
    snakeCase: $581749630132f166$var$snakeCase,
    kebabCase: $581749630132f166$var$kebabCase,
    sentenceCase: $581749630132f166$var$sentenceCase,
    titleCase: $581749630132f166$var$titleCase
};

});

parcelRegister("hPrfq", function(module, exports) {
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ module.exports = function(edges) {
    return $cfac55efc4fc1dd8$var$toposort($cfac55efc4fc1dd8$var$uniqueNodes(edges), edges);
};
module.exports.array = $cfac55efc4fc1dd8$var$toposort;
function $cfac55efc4fc1dd8$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $cfac55efc4fc1dd8$var$makeOutgoingEdges(edges), nodesHash = $cfac55efc4fc1dd8$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error("Cyclic dependency" + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $cfac55efc4fc1dd8$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $cfac55efc4fc1dd8$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $cfac55efc4fc1dd8$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}

});



parcelRegister("21h3m", function(module, exports) {

$parcel$export(module.exports, "prepareSchema", function () { return $cb6d104aaca0c8a1$export$16de2b0657bfce17; });

var $auyQS = parcelRequire("auyQS");
const $cb6d104aaca0c8a1$var$localization = {
    shouldUseOnlyUSAPhoneNumber: "Please use only US phone number like this +11234567890.",
    USAPhoneNumberLength: (length)=>`Phone number should be 10 digits after county code (+1), but your is ${length}`,
    emailOrPhoneIsRequired: "Email or Phone number is required.",
    invalidEmail: "Please enter valid E-mail address.",
    emailIsRequired: "Email is required.",
    shouldAgreeWithSMSAgreement: "Your consent to the sms agreement is required. Otherwise, you cannot register for the service.",
    shouldAgreeWithPrivacy: "Your consent to the Terms and Conditions is required. Otherwise, you cannot register for the service."
};
function $cb6d104aaca0c8a1$export$16de2b0657bfce17({ isEnabledSMSAgreement: isEnabledSMSAgreement = false, isEnabledPhoneNumber: isEnabledPhoneNumber = false, isEnabledCheckedAgreeWithPrivacy: isEnabledCheckedAgreeWithPrivacy = false }) {
    let schema = $auyQS.object().shape({});
    if (isEnabledPhoneNumber) {
        const contactSchema = $auyQS.string().test("email-or-us-phone", function(value = "") {
            if ($cb6d104aaca0c8a1$var$isPhoneNumber(value)) {
                if (!$cb6d104aaca0c8a1$var$isUSACountryCode(value)) return this.createError({
                    message: $cb6d104aaca0c8a1$var$localization.shouldUseOnlyUSAPhoneNumber
                });
                if (!$cb6d104aaca0c8a1$var$isUSAPhoneNumberByLength(value)) return this.createError({
                    message: $cb6d104aaca0c8a1$var$localization.USAPhoneNumberLength(value.slice(2).length)
                });
            } else if (!$auyQS.string().email().isValidSync(value)) return this.createError({
                message: $cb6d104aaca0c8a1$var$localization.invalidEmail
            });
            return true;
        }).required($cb6d104aaca0c8a1$var$localization.emailOrPhoneIsRequired);
        schema = schema.shape({
            contact: contactSchema
        });
    } else schema = schema.shape({
        contact: $auyQS.string().email($cb6d104aaca0c8a1$var$localization.invalidEmail).required($cb6d104aaca0c8a1$var$localization.emailIsRequired)
    });
    if (isEnabledSMSAgreement) schema = schema.shape({
        agreeWithSMSAgreement: $auyQS.boolean().oneOf([
            true
        ], $cb6d104aaca0c8a1$var$localization.shouldAgreeWithSMSAgreement)
    });
    if (isEnabledCheckedAgreeWithPrivacy) schema = schema.shape({
        agreeWithPrivacy: $auyQS.boolean().oneOf([
            true
        ], $cb6d104aaca0c8a1$var$localization.shouldAgreeWithPrivacy)
    });
    return schema;
}
function $cb6d104aaca0c8a1$var$isPhoneNumber(number) {
    return /^\d+$/.test(number) || /^\+\d+$/.test(number);
}
function $cb6d104aaca0c8a1$var$isUSACountryCode(phoneNumber) {
    return /^\+1/.test(phoneNumber);
}
function $cb6d104aaca0c8a1$var$isUSAPhoneNumberByLength(phoneNumber) {
    return /^\d{10}$/.test(phoneNumber.slice(2));
}

});


parcelRegister("hUmXJ", function(module, exports) {

$parcel$export(module.exports, "initSetLogo", function () { return $d0997a7b14a32508$export$7d8e4df93f4a60b0; });
const $d0997a7b14a32508$var$defaultLogo = "img/logo-1.png";
function $d0997a7b14a32508$export$7d8e4df93f4a60b0(logoCssPath, hiddenClassModifier, src) {
    const logo = document.querySelector(logoCssPath);
    if (src === "") logo.classList.add(hiddenClassModifier);
    else {
        logo.src = src || $d0997a7b14a32508$var$defaultLogo;
        logo.classList.remove(hiddenClassModifier);
    }
}

});

})();
//# sourceMappingURL=contact-completion.7a39c9d9.js.map
